/* tslint:disable */
/* auto-generated angular directive proxies */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Output, NgZone } from '@angular/core';

import { ProxyCmp } from './angular-component-lib/utils';

import type { Components } from '@bbraun/cortex-web/dist/components';

import { defineCustomElement as defineCwAccordion } from '@bbraun/cortex-web/dist/components/cw-accordion.js';
import { defineCustomElement as defineCwActionIcon } from '@bbraun/cortex-web/dist/components/cw-action-icon.js';
import { defineCustomElement as defineCwAvatar } from '@bbraun/cortex-web/dist/components/cw-avatar.js';
import { defineCustomElement as defineCwAvatarMenu } from '@bbraun/cortex-web/dist/components/cw-avatar-menu.js';
import { defineCustomElement as defineCwBadgeNotification } from '@bbraun/cortex-web/dist/components/cw-badge-notification.js';
import { defineCustomElement as defineCwBadgeStatus } from '@bbraun/cortex-web/dist/components/cw-badge-status.js';
import { defineCustomElement as defineCwBanner } from '@bbraun/cortex-web/dist/components/cw-banner.js';
import { defineCustomElement as defineCwBreadcrumbs } from '@bbraun/cortex-web/dist/components/cw-breadcrumbs.js';
import { defineCustomElement as defineCwBulletNavigation } from '@bbraun/cortex-web/dist/components/cw-bullet-navigation.js';
import { defineCustomElement as defineCwButton } from '@bbraun/cortex-web/dist/components/cw-button.js';
import { defineCustomElement as defineCwCard } from '@bbraun/cortex-web/dist/components/cw-card.js';
import { defineCustomElement as defineCwCardList } from '@bbraun/cortex-web/dist/components/cw-card-list.js';
import { defineCustomElement as defineCwCarousel } from '@bbraun/cortex-web/dist/components/cw-carousel.js';
import { defineCustomElement as defineCwCarouselFooter } from '@bbraun/cortex-web/dist/components/cw-carousel-footer.js';
import { defineCustomElement as defineCwCheckbox } from '@bbraun/cortex-web/dist/components/cw-checkbox.js';
import { defineCustomElement as defineCwChip } from '@bbraun/cortex-web/dist/components/cw-chip.js';
import { defineCustomElement as defineCwCombobox } from '@bbraun/cortex-web/dist/components/cw-combobox.js';
import { defineCustomElement as defineCwComboboxSelectItem } from '@bbraun/cortex-web/dist/components/cw-combobox-select-item.js';
import { defineCustomElement as defineCwDatepicker } from '@bbraun/cortex-web/dist/components/cw-datepicker.js';
import { defineCustomElement as defineCwDialog } from '@bbraun/cortex-web/dist/components/cw-dialog.js';
import { defineCustomElement as defineCwDivider } from '@bbraun/cortex-web/dist/components/cw-divider.js';
import { defineCustomElement as defineCwDropdown } from '@bbraun/cortex-web/dist/components/cw-dropdown.js';
import { defineCustomElement as defineCwDropdownGroup } from '@bbraun/cortex-web/dist/components/cw-dropdown-group.js';
import { defineCustomElement as defineCwDropdownItem } from '@bbraun/cortex-web/dist/components/cw-dropdown-item.js';
import { defineCustomElement as defineCwExpansionPanel } from '@bbraun/cortex-web/dist/components/cw-expansion-panel.js';
import { defineCustomElement as defineCwFileItem } from '@bbraun/cortex-web/dist/components/cw-file-item.js';
import { defineCustomElement as defineCwFileUploader } from '@bbraun/cortex-web/dist/components/cw-file-uploader.js';
import { defineCustomElement as defineCwHeader } from '@bbraun/cortex-web/dist/components/cw-header.js';
import { defineCustomElement as defineCwIcon } from '@bbraun/cortex-web/dist/components/cw-icon.js';
import { defineCustomElement as defineCwImage } from '@bbraun/cortex-web/dist/components/cw-image.js';
import { defineCustomElement as defineCwInput } from '@bbraun/cortex-web/dist/components/cw-input.js';
import { defineCustomElement as defineCwInputAssistive } from '@bbraun/cortex-web/dist/components/cw-input-assistive.js';
import { defineCustomElement as defineCwInputLabel } from '@bbraun/cortex-web/dist/components/cw-input-label.js';
import { defineCustomElement as defineCwInputNumber } from '@bbraun/cortex-web/dist/components/cw-input-number.js';
import { defineCustomElement as defineCwList } from '@bbraun/cortex-web/dist/components/cw-list.js';
import { defineCustomElement as defineCwListItem } from '@bbraun/cortex-web/dist/components/cw-list-item.js';
import { defineCustomElement as defineCwListItemDescription } from '@bbraun/cortex-web/dist/components/cw-list-item-description.js';
import { defineCustomElement as defineCwLogo } from '@bbraun/cortex-web/dist/components/cw-logo.js';
import { defineCustomElement as defineCwMenu } from '@bbraun/cortex-web/dist/components/cw-menu.js';
import { defineCustomElement as defineCwMenuItem } from '@bbraun/cortex-web/dist/components/cw-menu-item.js';
import { defineCustomElement as defineCwNavigationDrawer } from '@bbraun/cortex-web/dist/components/cw-navigation-drawer.js';
import { defineCustomElement as defineCwNavigationDrawerGroup } from '@bbraun/cortex-web/dist/components/cw-navigation-drawer-group.js';
import { defineCustomElement as defineCwNavigationDrawerItem } from '@bbraun/cortex-web/dist/components/cw-navigation-drawer-item.js';
import { defineCustomElement as defineCwNavigationDrawerSection } from '@bbraun/cortex-web/dist/components/cw-navigation-drawer-section.js';
import { defineCustomElement as defineCwNavigationRail } from '@bbraun/cortex-web/dist/components/cw-navigation-rail.js';
import { defineCustomElement as defineCwNavigationRailGroup } from '@bbraun/cortex-web/dist/components/cw-navigation-rail-group.js';
import { defineCustomElement as defineCwNavigationRailItem } from '@bbraun/cortex-web/dist/components/cw-navigation-rail-item.js';
import { defineCustomElement as defineCwNavigationRailSection } from '@bbraun/cortex-web/dist/components/cw-navigation-rail-section.js';
import { defineCustomElement as defineCwNavigationRailTitle } from '@bbraun/cortex-web/dist/components/cw-navigation-rail-title.js';
import { defineCustomElement as defineCwPagination } from '@bbraun/cortex-web/dist/components/cw-pagination.js';
import { defineCustomElement as defineCwPaginationControls } from '@bbraun/cortex-web/dist/components/cw-pagination-controls.js';
import { defineCustomElement as defineCwPopover } from '@bbraun/cortex-web/dist/components/cw-popover.js';
import { defineCustomElement as defineCwPopoverHeader } from '@bbraun/cortex-web/dist/components/cw-popover-header.js';
import { defineCustomElement as defineCwProgressBar } from '@bbraun/cortex-web/dist/components/cw-progress-bar.js';
import { defineCustomElement as defineCwRadioButton } from '@bbraun/cortex-web/dist/components/cw-radio-button.js';
import { defineCustomElement as defineCwRadioGroup } from '@bbraun/cortex-web/dist/components/cw-radio-group.js';
import { defineCustomElement as defineCwSearchbar } from '@bbraun/cortex-web/dist/components/cw-searchbar.js';
import { defineCustomElement as defineCwSearchbarItem } from '@bbraun/cortex-web/dist/components/cw-searchbar-item.js';
import { defineCustomElement as defineCwSidebar } from '@bbraun/cortex-web/dist/components/cw-sidebar.js';
import { defineCustomElement as defineCwSlider } from '@bbraun/cortex-web/dist/components/cw-slider.js';
import { defineCustomElement as defineCwSnackbar } from '@bbraun/cortex-web/dist/components/cw-snackbar.js';
import { defineCustomElement as defineCwSnackbarItem } from '@bbraun/cortex-web/dist/components/cw-snackbar-item.js';
import { defineCustomElement as defineCwSpinner } from '@bbraun/cortex-web/dist/components/cw-spinner.js';
import { defineCustomElement as defineCwSplashScreen } from '@bbraun/cortex-web/dist/components/cw-splash-screen.js';
import { defineCustomElement as defineCwStepper } from '@bbraun/cortex-web/dist/components/cw-stepper.js';
import { defineCustomElement as defineCwTab } from '@bbraun/cortex-web/dist/components/cw-tab.js';
import { defineCustomElement as defineCwTable } from '@bbraun/cortex-web/dist/components/cw-table.js';
import { defineCustomElement as defineCwTableToggleColumn } from '@bbraun/cortex-web/dist/components/cw-table-toggle-column.js';
import { defineCustomElement as defineCwTextarea } from '@bbraun/cortex-web/dist/components/cw-textarea.js';
import { defineCustomElement as defineCwToggle } from '@bbraun/cortex-web/dist/components/cw-toggle.js';
import { defineCustomElement as defineCwTooltip } from '@bbraun/cortex-web/dist/components/cw-tooltip.js';
import { defineCustomElement as defineCwWizard } from '@bbraun/cortex-web/dist/components/cw-wizard.js';
import { defineCustomElement as defineCwWizardActions } from '@bbraun/cortex-web/dist/components/cw-wizard-actions.js';
import { defineCustomElement as defineCwWizardBody } from '@bbraun/cortex-web/dist/components/cw-wizard-body.js';
@ProxyCmp({
  defineCustomElementFn: defineCwAccordion
})
@Component({
  selector: 'cw-accordion',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class CwAccordion {
  protected el: HTMLCwAccordionElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwAccordion extends Components.CwAccordion {}


@ProxyCmp({
  defineCustomElementFn: defineCwActionIcon,
  inputs: ['active', 'ariaLabel', 'disabled', 'error', 'filled', 'font', 'icon', 'selected', 'size']
})
@Component({
  selector: 'cw-action-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'ariaLabel', 'disabled', 'error', 'filled', 'font', 'icon', 'selected', 'size'],
  outputs: ['activeChange'],
})
export class CwActionIcon {
  protected el: HTMLCwActionIconElement;
    /**
   *  @default ''
   */
  set icon(_: Components.CwActionIcon['icon']) {};
    /**
   *  @default 24
   */
  set size(_: Components.CwActionIcon['size']) {};
    /**
   *  @default 'material'
   */
  set font(_: Components.CwActionIcon['font']) {};
    /**
   *  @default false
   */
  set active(_: Components.CwActionIcon['active']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwActionIcon['disabled']) {};
    /**
   *  @default false
   */
  set selected(_: Components.CwActionIcon['selected']) {};
    /**
   *  @default false
   */
  set filled(_: Components.CwActionIcon['filled']) {};
    /**
   *  @default false
   */
  set error(_: Components.CwActionIcon['error']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwActionIcon['ariaLabel']) {};
  @Output() activeChange = new EventEmitter<CwActionIconCustomEvent<{ isActive: boolean }>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwActionIconCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwActionIcon extends Components.CwActionIcon {

  activeChange: EventEmitter<CwActionIconCustomEvent<{ isActive: boolean }>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwAvatar,
  inputs: ['active', 'ariaLabel', 'avatarType', 'firstName', 'icon', 'imageUrl', 'isOnline', 'lastName', 'online', 'size', 'state', 'status', 'surface']
})
@Component({
  selector: 'cw-avatar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'ariaLabel', 'avatarType', 'firstName', 'icon', 'imageUrl', 'isOnline', 'lastName', 'online', 'size', 'state', 'status', 'surface'],
  outputs: ['activeChange'],
})
export class CwAvatar {
  protected el: HTMLCwAvatarElement;
    /**
   *  @default 'md'
   */
  set size(_: Components.CwAvatar['size']) {};
    /**
   *  @default false
   */
  set status(_: Components.CwAvatar['status']) {};
    /**
   *  @default false
   */
  set isOnline(_: Components.CwAvatar['isOnline']) {};
    /**
   *  @default false
   */
  set active(_: Components.CwAvatar['active']) {};
    /**
   *  @default 'onDefault'
   */
  set surface(_: Components.CwAvatar['surface']) {};
    /**
   *  @default 'image'
   */
  set avatarType(_: Components.CwAvatar['avatarType']) {};
    /**
   *  @default ''
   */
  set firstName(_: Components.CwAvatar['firstName']) {};
    /**
   *  @default ''
   */
  set lastName(_: Components.CwAvatar['lastName']) {};
    /**
   *  @default ''
   */
  set imageUrl(_: Components.CwAvatar['imageUrl']) {};
    /**
   *  @default ''
   */
  set icon(_: Components.CwAvatar['icon']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwAvatar['ariaLabel']) {};
    /**
   *  @deprecated Use `status` and `online` props instead. Will be removed in v2.0.0
- state="online" → status={true} + online={true}
- state="offline" → status={true} + online={false}
- state="none" → status={false}
   */
  set state(_: Components.CwAvatar['state']) {};
    /**
   *  @deprecated Use `isOnline` instead. Will be removed in v2.0.0,@default false
   */
  set online(_: Components.CwAvatar['online']) {};
  @Output() activeChange = new EventEmitter<CwAvatarCustomEvent<{ isActive: boolean }>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwAvatarCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwAvatar extends Components.CwAvatar {

  activeChange: EventEmitter<CwAvatarCustomEvent<{ isActive: boolean }>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwAvatarMenu,
  inputs: ['activeItem', 'avatarType', 'email', 'firstName', 'imageUrl', 'isOnline', 'labels', 'lastName', 'online', 'showProfileSettings', 'showSwitchOrganisations', 'status']
})
@Component({
  selector: 'cw-avatar-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['activeItem', 'avatarType', 'email', 'firstName', 'imageUrl', 'isOnline', 'labels', 'lastName', 'online', 'showProfileSettings', 'showSwitchOrganisations', 'status'],
  outputs: ['navigate'],
})
export class CwAvatarMenu {
  protected el: HTMLCwAvatarMenuElement;
    /**
   *  @default ''
   */
  set firstName(_: Components.CwAvatarMenu['firstName']) {};
    /**
   *  @default ''
   */
  set lastName(_: Components.CwAvatarMenu['lastName']) {};
    /**
   *  @default ''
   */
  set email(_: Components.CwAvatarMenu['email']) {};
    /**
   *  @default ''
   */
  set imageUrl(_: Components.CwAvatarMenu['imageUrl']) {};
    /**
   *  @default 'letters'
   */
  set avatarType(_: Components.CwAvatarMenu['avatarType']) {};
    /**
   *  @default false
   */
  set status(_: Components.CwAvatarMenu['status']) {};
    /**
   *  @default false
   */
  set isOnline(_: Components.CwAvatarMenu['isOnline']) {};
    /**
   *  @default false
   */
  set showSwitchOrganisations(_: Components.CwAvatarMenu['showSwitchOrganisations']) {};
    /**
   *  @deprecated Use `isOnline` instead. Will be removed in v2.0.0,@default false
   */
  set online(_: Components.CwAvatarMenu['online']) {};
    /**
   *  @default false
   */
  set showProfileSettings(_: Components.CwAvatarMenu['showProfileSettings']) {};
    /**
   *  @default {}
   */
  set labels(_: Components.CwAvatarMenu['labels']) {};
  
  set activeItem(_: Components.CwAvatarMenu['activeItem']) {};
  @Output() navigate = new EventEmitter<CwAvatarMenuCustomEvent<ICwAvatarMenuCwAvatarMenuLink>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwAvatarMenuCustomEvent } from '@bbraun/cortex-web/dist/components';
import type { CwAvatarMenuLink as ICwAvatarMenuCwAvatarMenuLink } from '@bbraun/cortex-web/dist/components';

export declare interface CwAvatarMenu extends Components.CwAvatarMenu {

  navigate: EventEmitter<CwAvatarMenuCustomEvent<ICwAvatarMenuCwAvatarMenuLink>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwBadgeNotification,
  inputs: ['ariaLabel', 'size', 'value']
})
@Component({
  selector: 'cw-badge-notification',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'size', 'value'],
})
export class CwBadgeNotification {
  protected el: HTMLCwBadgeNotificationElement;
    /**
   *  @default BadgeNotificationSizes.MD
   */
  set size(_: Components.CwBadgeNotification['size']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwBadgeNotification['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set value(_: Components.CwBadgeNotification['value']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwBadgeNotification extends Components.CwBadgeNotification {}


@ProxyCmp({
  defineCustomElementFn: defineCwBadgeStatus,
  inputs: ['ariaLabel', 'font', 'icon', 'label', 'priority', 'status']
})
@Component({
  selector: 'cw-badge-status',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'font', 'icon', 'label', 'priority', 'status'],
})
export class CwBadgeStatus {
  protected el: HTMLCwBadgeStatusElement;
    /**
   *  @default BadgeStatusPriority.HIGH
   */
  set priority(_: Components.CwBadgeStatus['priority']) {};
    /**
   *  @default BadgeStatus.DEFAULT
   */
  set status(_: Components.CwBadgeStatus['status']) {};
  
  set label(_: Components.CwBadgeStatus['label']) {};
  
  set icon(_: Components.CwBadgeStatus['icon']) {};
    /**
   *  @default 'material'
   */
  set font(_: Components.CwBadgeStatus['font']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwBadgeStatus['ariaLabel']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwBadgeStatus extends Components.CwBadgeStatus {}


@ProxyCmp({
  defineCustomElementFn: defineCwBanner,
  inputs: ['actionButtonLabel', 'ariaLabel', 'closeButtonAriaLabel', 'description', 'enableClose', 'label', 'type']
})
@Component({
  selector: 'cw-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['actionButtonLabel', 'ariaLabel', 'closeButtonAriaLabel', 'description', 'enableClose', 'label', 'type'],
  outputs: ['actionButtonClicked', 'closeButtonClicked'],
})
export class CwBanner {
  protected el: HTMLCwBannerElement;
    /**
   *  @default 'info'
   */
  set type(_: Components.CwBanner['type']) {};
  
  set label(_: Components.CwBanner['label']) {};
  
  set description(_: Components.CwBanner['description']) {};
  
  set actionButtonLabel(_: Components.CwBanner['actionButtonLabel']) {};
    /**
   *  @default true
   */
  set enableClose(_: Components.CwBanner['enableClose']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwBanner['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set closeButtonAriaLabel(_: Components.CwBanner['closeButtonAriaLabel']) {};
  @Output() actionButtonClicked = new EventEmitter<CwBannerCustomEvent<MouseEvent>>();
  @Output() closeButtonClicked = new EventEmitter<CwBannerCustomEvent<MouseEvent>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwBannerCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwBanner extends Components.CwBanner {

  actionButtonClicked: EventEmitter<CwBannerCustomEvent<MouseEvent>>;

  closeButtonClicked: EventEmitter<CwBannerCustomEvent<MouseEvent>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwBreadcrumbs,
  inputs: ['ariaLabel', 'currentPage', 'items']
})
@Component({
  selector: 'cw-breadcrumbs',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'currentPage', 'items'],
  outputs: ['navigate'],
})
export class CwBreadcrumbs {
  protected el: HTMLCwBreadcrumbsElement;
  
  set currentPage(_: Components.CwBreadcrumbs['currentPage']) {};
    /**
   *  @default []
   */
  set items(_: Components.CwBreadcrumbs['items']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwBreadcrumbs['ariaLabel']) {};
  @Output() navigate = new EventEmitter<CwBreadcrumbsCustomEvent<string>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwBreadcrumbsCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwBreadcrumbs extends Components.CwBreadcrumbs {

  navigate: EventEmitter<CwBreadcrumbsCustomEvent<string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwBulletNavigation,
  inputs: ['active', 'ariaLabel', 'disableNavigation', 'isLooping', 'total']
})
@Component({
  selector: 'cw-bullet-navigation',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'ariaLabel', 'disableNavigation', 'isLooping', 'total'],
  outputs: ['bulletSelected', 'arrowLeft', 'arrowRight'],
})
export class CwBulletNavigation {
  protected el: HTMLCwBulletNavigationElement;
    /**
   *  @default 0
   */
  set total(_: Components.CwBulletNavigation['total']) {};
    /**
   *  @default 0
   */
  set active(_: Components.CwBulletNavigation['active']) {};
    /**
   *  @default false
   */
  set isLooping(_: Components.CwBulletNavigation['isLooping']) {};
    /**
   *  @default false
   */
  set disableNavigation(_: Components.CwBulletNavigation['disableNavigation']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwBulletNavigation['ariaLabel']) {};
  @Output() bulletSelected = new EventEmitter<CwBulletNavigationCustomEvent<number>>();
  @Output() arrowLeft = new EventEmitter<CwBulletNavigationCustomEvent<void>>();
  @Output() arrowRight = new EventEmitter<CwBulletNavigationCustomEvent<void>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwBulletNavigationCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwBulletNavigation extends Components.CwBulletNavigation {

  bulletSelected: EventEmitter<CwBulletNavigationCustomEvent<number>>;
  /**
   *  @deprecated Legacy event. Use bulletSelected instead.
   */
  arrowLeft: EventEmitter<CwBulletNavigationCustomEvent<void>>;
  /**
   *  @deprecated Legacy event. Use bulletSelected instead.
   */
  arrowRight: EventEmitter<CwBulletNavigationCustomEvent<void>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwButton,
  inputs: ['ariaLabel', 'as', 'buttonColor', 'disabled', 'download', 'href', 'rel', 'target', 'type', 'variant']
})
@Component({
  selector: 'cw-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'as', 'buttonColor', 'disabled', 'download', 'href', 'rel', 'target', 'type', 'variant'],
})
export class CwButton {
  protected el: HTMLCwButtonElement;
    /**
   *  @default 'filled'
   */
  set variant(_: Components.CwButton['variant']) {};
    /**
   *  @default 'accent'
   */
  set buttonColor(_: Components.CwButton['buttonColor']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwButton['disabled']) {};
    /**
   *  @default 'button'
   */
  set type(_: Components.CwButton['type']) {};
    /**
   *  @default 'button'
   */
  set as(_: Components.CwButton['as']) {};
    /**
   *  @default ''
   */
  set href(_: Components.CwButton['href']) {};
    /**
   *  @default ''
   */
  set target(_: Components.CwButton['target']) {};
    /**
   *  @default ''
   */
  set rel(_: Components.CwButton['rel']) {};
    /**
   *  @default ''
   */
  set download(_: Components.CwButton['download']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwButton['ariaLabel']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwButton extends Components.CwButton {}


@ProxyCmp({
  defineCustomElementFn: defineCwCard,
  inputs: ['ariaLabel', 'ariaLabelledby', 'avatarImgUrl', 'cardSubTitle', 'cardTitle', 'checked', 'clickable', 'custom', 'description', 'height', 'selected', 'showSelect', 'size', 'type', 'value', 'width']
})
@Component({
  selector: 'cw-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelledby', 'avatarImgUrl', 'cardSubTitle', 'cardTitle', 'checked', 'clickable', 'custom', 'description', 'height', 'selected', 'showSelect', 'size', 'type', 'value', 'width'],
  outputs: ['cardSelected'],
})
export class CwCard {
  protected el: HTMLCwCardElement;
    /**
   *  @default 'vertical'
   */
  set type(_: Components.CwCard['type']) {};
    /**
   *  @default 'medium'
   */
  set size(_: Components.CwCard['size']) {};
    /**
   *  @default false
   */
  set custom(_: Components.CwCard['custom']) {};
  
  set cardTitle(_: Components.CwCard['cardTitle']) {};
  
  set cardSubTitle(_: Components.CwCard['cardSubTitle']) {};
  
  set description(_: Components.CwCard['description']) {};
  
  set avatarImgUrl(_: Components.CwCard['avatarImgUrl']) {};
    /**
   *  @default false
   */
  set showSelect(_: Components.CwCard['showSelect']) {};
    /**
   *  @default false
   */
  set checked(_: Components.CwCard['checked']) {};
  
  set clickable(_: Components.CwCard['clickable']) {};
    /**
   *  @default ''
   */
  set value(_: Components.CwCard['value']) {};
  
  set height(_: Components.CwCard['height']) {};
  
  set width(_: Components.CwCard['width']) {};
    /**
   *  @default false
   */
  set selected(_: Components.CwCard['selected']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwCard['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwCard['ariaLabelledby']) {};
  @Output() cardSelected = new EventEmitter<CwCardCustomEvent<ICwCardCardListOption>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwCardCustomEvent } from '@bbraun/cortex-web/dist/components';
import type { CardListOption as ICwCardCardListOption } from '@bbraun/cortex-web/dist/components';

export declare interface CwCard extends Components.CwCard {

  cardSelected: EventEmitter<CwCardCustomEvent<ICwCardCardListOption>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwCardList,
  inputs: ['ariaLabel', 'ariaLabelledby', 'multiple', 'selectedCardOptions']
})
@Component({
  selector: 'cw-card-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelledby', 'multiple', 'selectedCardOptions'],
  outputs: ['selectionChanged'],
})
export class CwCardList {
  protected el: HTMLCwCardListElement;
    /**
   *  @default false
   */
  set multiple(_: Components.CwCardList['multiple']) {};
    /**
   *  @default []
   */
  set selectedCardOptions(_: Components.CwCardList['selectedCardOptions']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwCardList['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwCardList['ariaLabelledby']) {};
  @Output() selectionChanged = new EventEmitter<CwCardListCustomEvent<any>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwCardListCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwCardList extends Components.CwCardList {

  selectionChanged: EventEmitter<CwCardListCustomEvent<any>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwCarousel,
  inputs: ['actions', 'ariaLabel', 'ariaLabelledby', 'deleteAllImagesAriaLabel', 'deleteAllImagesMenuItemText', 'deleteImageAriaLabel', 'deleteImageMenuItemText', 'description', 'disableAddPhotoButton', 'height', 'imageCounterAriaLabel', 'images', 'menuTriggerAriaLabel', 'type', 'uploadImageAriaLabel', 'uploadImageMenuItemText', 'width']
})
@Component({
  selector: 'cw-carousel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['actions', 'ariaLabel', 'ariaLabelledby', 'deleteAllImagesAriaLabel', 'deleteAllImagesMenuItemText', 'deleteImageAriaLabel', 'deleteImageMenuItemText', 'description', 'disableAddPhotoButton', 'height', 'imageCounterAriaLabel', 'images', 'menuTriggerAriaLabel', 'type', 'uploadImageAriaLabel', 'uploadImageMenuItemText', 'width'],
  outputs: ['imageDeleted', 'allImagesDeleted', 'imageSelected'],
})
export class CwCarousel {
  protected el: HTMLCwCarouselElement;
    /**
   *  @default 'no-image'
   */
  set type(_: Components.CwCarousel['type']) {};
  
  set height(_: Components.CwCarousel['height']) {};
  
  set width(_: Components.CwCarousel['width']) {};
    /**
   *  @default true
   */
  set actions(_: Components.CwCarousel['actions']) {};
    /**
   *  @default false
   */
  set disableAddPhotoButton(_: Components.CwCarousel['disableAddPhotoButton']) {};
  
  set description(_: Components.CwCarousel['description']) {};
    /**
   *  @default []
   */
  set images(_: Components.CwCarousel['images']) {};
  
  set uploadImageMenuItemText(_: Components.CwCarousel['uploadImageMenuItemText']) {};
  
  set deleteImageMenuItemText(_: Components.CwCarousel['deleteImageMenuItemText']) {};
  
  set deleteAllImagesMenuItemText(_: Components.CwCarousel['deleteAllImagesMenuItemText']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwCarousel['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwCarousel['ariaLabelledby']) {};
    /**
   *  @default undefined
   */
  set uploadImageAriaLabel(_: Components.CwCarousel['uploadImageAriaLabel']) {};
    /**
   *  @default undefined
   */
  set deleteImageAriaLabel(_: Components.CwCarousel['deleteImageAriaLabel']) {};
    /**
   *  @default undefined
   */
  set deleteAllImagesAriaLabel(_: Components.CwCarousel['deleteAllImagesAriaLabel']) {};
    /**
   *  @default undefined
   */
  set menuTriggerAriaLabel(_: Components.CwCarousel['menuTriggerAriaLabel']) {};
    /**
   *  @default undefined
   */
  set imageCounterAriaLabel(_: Components.CwCarousel['imageCounterAriaLabel']) {};
  @Output() imageDeleted = new EventEmitter<CwCarouselCustomEvent<ICwCarouselCwCarouselFooterCustomEvent<number | string>>>();
  @Output() allImagesDeleted = new EventEmitter<CwCarouselCustomEvent<ICwCarouselCwCarouselFooterCustomEvent<number | string>>>();
  @Output() imageSelected = new EventEmitter<CwCarouselCustomEvent<FileList>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwCarouselCustomEvent } from '@bbraun/cortex-web/dist/components';
import type { CwCarouselFooterCustomEvent as ICwCarouselCwCarouselFooterCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwCarousel extends Components.CwCarousel {

  imageDeleted: EventEmitter<CwCarouselCustomEvent<ICwCarouselCwCarouselFooterCustomEvent<number | string>>>;

  allImagesDeleted: EventEmitter<CwCarouselCustomEvent<ICwCarouselCwCarouselFooterCustomEvent<number | string>>>;

  imageSelected: EventEmitter<CwCarouselCustomEvent<FileList>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwCarouselFooter,
  inputs: ['actions', 'currentImageIndex', 'deleteAllImagesAriaLabel', 'deleteAllImagesMenuItemText', 'deleteImageAriaLabel', 'deleteImageMenuItemText', 'description', 'disableAddPhotoButton', 'imageCounterAriaLabel', 'images', 'menuTriggerAriaLabel', 'type', 'uploadImageAriaLabel', 'uploadImageMenuItemText']
})
@Component({
  selector: 'cw-carousel-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['actions', 'currentImageIndex', 'deleteAllImagesAriaLabel', 'deleteAllImagesMenuItemText', 'deleteImageAriaLabel', 'deleteImageMenuItemText', 'description', 'disableAddPhotoButton', 'imageCounterAriaLabel', 'images', 'menuTriggerAriaLabel', 'type', 'uploadImageAriaLabel', 'uploadImageMenuItemText'],
  outputs: ['imageDeleted', 'allImagesDeleted', 'imageSelected', 'currentImageIndexChange'],
})
export class CwCarouselFooter {
  protected el: HTMLCwCarouselFooterElement;
    /**
   *  @default 'no-image'
   */
  set type(_: Components.CwCarouselFooter['type']) {};
    /**
   *  @default true
   */
  set actions(_: Components.CwCarouselFooter['actions']) {};
    /**
   *  @default false
   */
  set disableAddPhotoButton(_: Components.CwCarouselFooter['disableAddPhotoButton']) {};
  
  set description(_: Components.CwCarouselFooter['description']) {};
    /**
   *  @default []
   */
  set images(_: Components.CwCarouselFooter['images']) {};
  
  set uploadImageMenuItemText(_: Components.CwCarouselFooter['uploadImageMenuItemText']) {};
  
  set deleteImageMenuItemText(_: Components.CwCarouselFooter['deleteImageMenuItemText']) {};
  
  set deleteAllImagesMenuItemText(_: Components.CwCarouselFooter['deleteAllImagesMenuItemText']) {};
    /**
   *  @default 0
   */
  set currentImageIndex(_: Components.CwCarouselFooter['currentImageIndex']) {};
    /**
   *  @default undefined
   */
  set uploadImageAriaLabel(_: Components.CwCarouselFooter['uploadImageAriaLabel']) {};
    /**
   *  @default undefined
   */
  set deleteImageAriaLabel(_: Components.CwCarouselFooter['deleteImageAriaLabel']) {};
    /**
   *  @default undefined
   */
  set deleteAllImagesAriaLabel(_: Components.CwCarouselFooter['deleteAllImagesAriaLabel']) {};
    /**
   *  @default undefined
   */
  set menuTriggerAriaLabel(_: Components.CwCarouselFooter['menuTriggerAriaLabel']) {};
    /**
   *  @default undefined
   */
  set imageCounterAriaLabel(_: Components.CwCarouselFooter['imageCounterAriaLabel']) {};
  @Output() imageDeleted = new EventEmitter<CwCarouselFooterCustomEvent<number | string>>();
  @Output() allImagesDeleted = new EventEmitter<CwCarouselFooterCustomEvent<number | string>>();
  @Output() imageSelected = new EventEmitter<CwCarouselFooterCustomEvent<FileList>>();
  @Output() currentImageIndexChange = new EventEmitter<CwCarouselFooterCustomEvent<number>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwCarouselFooterCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwCarouselFooter extends Components.CwCarouselFooter {

  imageDeleted: EventEmitter<CwCarouselFooterCustomEvent<number | string>>;

  allImagesDeleted: EventEmitter<CwCarouselFooterCustomEvent<number | string>>;

  imageSelected: EventEmitter<CwCarouselFooterCustomEvent<FileList>>;

  currentImageIndexChange: EventEmitter<CwCarouselFooterCustomEvent<number>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwCheckbox,
  inputs: ['ariaLabel', 'ariaLabelledby', 'checked', 'disabled', 'indeterminate', 'suppressRipple']
})
@Component({
  selector: 'cw-checkbox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelledby', 'checked', 'disabled', 'indeterminate', 'suppressRipple'],
  outputs: ['checkboxChange'],
})
export class CwCheckbox {
  protected el: HTMLCwCheckboxElement;
    /**
   *  @default false
   */
  set checked(_: Components.CwCheckbox['checked']) {};
    /**
   *  @default false
   */
  set indeterminate(_: Components.CwCheckbox['indeterminate']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwCheckbox['disabled']) {};
    /**
   *  @default false
   */
  set suppressRipple(_: Components.CwCheckbox['suppressRipple']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwCheckbox['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwCheckbox['ariaLabelledby']) {};
  @Output() checkboxChange = new EventEmitter<CwCheckboxCustomEvent<boolean>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwCheckboxCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwCheckbox extends Components.CwCheckbox {

  checkboxChange: EventEmitter<CwCheckboxCustomEvent<boolean>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwChip,
  inputs: ['ariaLabel', 'ariaLabelledby', 'chipTabIndex', 'clickable', 'deletable', 'deletableIcon', 'disabled', 'icon', 'readonly', 'state', 'text', 'trailingIcon', 'type']
})
@Component({
  selector: 'cw-chip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelledby', 'chipTabIndex', 'clickable', 'deletable', 'deletableIcon', 'disabled', 'icon', 'readonly', 'state', 'text', 'trailingIcon', 'type'],
  outputs: ['actionIconClick', 'chipClick'],
})
export class CwChip {
  protected el: HTMLCwChipElement;
    /**
   *  @default 'radio'
   */
  set type(_: Components.CwChip['type']) {};
    /**
   *  @default 'regular'
   */
  set state(_: Components.CwChip['state']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwChip['disabled']) {};
    /**
   *  @default false
   */
  set readonly(_: Components.CwChip['readonly']) {};
    /**
   *  @deprecated Use native tabindex attribute instead. Will be removed in v2.0.0,@default 0
   */
  set chipTabIndex(_: Components.CwChip['chipTabIndex']) {};
  
  set icon(_: Components.CwChip['icon']) {};
  
  set text(_: Components.CwChip['text']) {};
  
  set trailingIcon(_: Components.CwChip['trailingIcon']) {};
    /**
   *  @default false
   */
  set deletable(_: Components.CwChip['deletable']) {};
  
  set deletableIcon(_: Components.CwChip['deletableIcon']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwChip['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwChip['ariaLabelledby']) {};
    /**
   *  @default true
   */
  set clickable(_: Components.CwChip['clickable']) {};
  @Output() actionIconClick = new EventEmitter<CwChipCustomEvent<MouseEvent>>();
  @Output() chipClick = new EventEmitter<CwChipCustomEvent<MouseEvent>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwChipCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwChip extends Components.CwChip {

  actionIconClick: EventEmitter<CwChipCustomEvent<MouseEvent>>;

  chipClick: EventEmitter<CwChipCustomEvent<MouseEvent>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwCombobox,
  inputs: ['ariaLabel', 'ariaLabelledby', 'assistiveText', 'asyncLoad', 'chipLayout', 'clearIconAriaLabel', 'disabled', 'label', 'loadingMessage', 'loadingOptions', 'multiSelect', 'noResultsMessage', 'openDropdownOnFocus', 'options', 'placeholder', 'readonly', 'required', 'requiredText', 'selectedAtTop', 'status', 'toggleIconAriaLabel', 'value', 'values']
})
@Component({
  selector: 'cw-combobox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelledby', 'assistiveText', 'asyncLoad', 'chipLayout', 'clearIconAriaLabel', 'disabled', 'label', 'loadingMessage', 'loadingOptions', 'multiSelect', 'noResultsMessage', 'openDropdownOnFocus', 'options', 'placeholder', 'readonly', 'required', 'requiredText', 'selectedAtTop', 'status', 'toggleIconAriaLabel', 'value', 'values'],
  outputs: ['valueChange', 'loadAsyncValues', 'inputChange'],
})
export class CwCombobox {
  protected el: HTMLCwComboboxElement;
    /**
   *  @default []
   */
  set options(_: Components.CwCombobox['options']) {};
    /**
   *  @default false
   */
  set asyncLoad(_: Components.CwCombobox['asyncLoad']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwCombobox['disabled']) {};
    /**
   *  @default false
   */
  set required(_: Components.CwCombobox['required']) {};
    /**
   *  @default false
   */
  set readonly(_: Components.CwCombobox['readonly']) {};
    /**
   *  @default ''
   */
  set placeholder(_: Components.CwCombobox['placeholder']) {};
  
  set value(_: Components.CwCombobox['value']) {};
    /**
   *  @default []
   */
  set values(_: Components.CwCombobox['values']) {};
  
  set label(_: Components.CwCombobox['label']) {};
  
  set assistiveText(_: Components.CwCombobox['assistiveText']) {};
    /**
   *  @default null
   */
  set status(_: Components.CwCombobox['status']) {};
    /**
   *  @default ''
   */
  set noResultsMessage(_: Components.CwCombobox['noResultsMessage']) {};
    /**
   *  @default ''
   */
  set requiredText(_: Components.CwCombobox['requiredText']) {};
    /**
   *  @default ''
   */
  set loadingMessage(_: Components.CwCombobox['loadingMessage']) {};
    /**
   *  @default false
   */
  set multiSelect(_: Components.CwCombobox['multiSelect']) {};
    /**
   *  @default false
   */
  set loadingOptions(_: Components.CwCombobox['loadingOptions']) {};
    /**
   *  @default ChipLayout.MultiLine
   */
  set chipLayout(_: Components.CwCombobox['chipLayout']) {};
    /**
   *  @default false
   */
  set selectedAtTop(_: Components.CwCombobox['selectedAtTop']) {};
    /**
   *  @default false
   */
  set openDropdownOnFocus(_: Components.CwCombobox['openDropdownOnFocus']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwCombobox['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwCombobox['ariaLabelledby']) {};
    /**
   *  @default undefined
   */
  set clearIconAriaLabel(_: Components.CwCombobox['clearIconAriaLabel']) {};
    /**
   *  @default undefined
   */
  set toggleIconAriaLabel(_: Components.CwCombobox['toggleIconAriaLabel']) {};
  @Output() valueChange = new EventEmitter<CwComboboxCustomEvent<string | string[]>>();
  @Output() loadAsyncValues = new EventEmitter<CwComboboxCustomEvent<void>>();
  @Output() inputChange = new EventEmitter<CwComboboxCustomEvent<string>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwComboboxCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwCombobox extends Components.CwCombobox {

  valueChange: EventEmitter<CwComboboxCustomEvent<string | string[]>>;

  loadAsyncValues: EventEmitter<CwComboboxCustomEvent<void>>;

  inputChange: EventEmitter<CwComboboxCustomEvent<string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwComboboxSelectItem,
  inputs: ['multiselect', 'option', 'selected']
})
@Component({
  selector: 'cw-combobox-select-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['multiselect', 'option', 'selected'],
  outputs: ['itemSelect'],
})
export class CwComboboxSelectItem {
  protected el: HTMLCwComboboxSelectItemElement;
  
  set option(_: Components.CwComboboxSelectItem['option']) {};
    /**
   *  @default false
   */
  set selected(_: Components.CwComboboxSelectItem['selected']) {};
    /**
   *  @default false
   */
  set multiselect(_: Components.CwComboboxSelectItem['multiselect']) {};
  @Output() itemSelect = new EventEmitter<CwComboboxSelectItemCustomEvent<void>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwComboboxSelectItemCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwComboboxSelectItem extends Components.CwComboboxSelectItem {

  itemSelect: EventEmitter<CwComboboxSelectItemCustomEvent<void>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwDatepicker,
  inputs: ['ariaDescribedby', 'ariaLabel', 'ariaLabelledby', 'assistiveText', 'clearable', 'dateFormat', 'disableDates', 'disabled', 'enableTime', 'label', 'locale', 'maxDate', 'minDate', 'mode', 'noCalendar', 'open', 'placeholder', 'position', 'readonly', 'required', 'showAmPm', 'status', 'value', 'weekNumbers', 'yearsAfter', 'yearsBefore']
})
@Component({
  selector: 'cw-datepicker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaDescribedby', 'ariaLabel', 'ariaLabelledby', 'assistiveText', 'clearable', 'dateFormat', 'disableDates', 'disabled', 'enableTime', 'label', 'locale', 'maxDate', 'minDate', 'mode', 'noCalendar', 'open', 'placeholder', 'position', 'readonly', 'required', 'showAmPm', 'status', 'value', 'weekNumbers', 'yearsAfter', 'yearsBefore'],
  outputs: ['dateChange', 'calendarOpen', 'calendarClose'],
})
export class CwDatepicker {
  protected el: HTMLCwDatepickerElement;
  
  set assistiveText(_: Components.CwDatepicker['assistiveText']) {};
  
  set clearable(_: Components.CwDatepicker['clearable']) {};
    /**
   *  @default null
   */
  set dateFormat(_: Components.CwDatepicker['dateFormat']) {};
  
  set disabled(_: Components.CwDatepicker['disabled']) {};
    /**
   *  @default []
   */
  set disableDates(_: Components.CwDatepicker['disableDates']) {};
    /**
   *  @default false
   */
  set enableTime(_: Components.CwDatepicker['enableTime']) {};
    /**
   *  @default null
   */
  set label(_: Components.CwDatepicker['label']) {};
    /**
   *  @default null
   */
  set maxDate(_: Components.CwDatepicker['maxDate']) {};
    /**
   *  @default null
   */
  set minDate(_: Components.CwDatepicker['minDate']) {};
    /**
   *  @default CwDatePickerMode.SINGLE
   */
  set mode(_: Components.CwDatepicker['mode']) {};
  
  set noCalendar(_: Components.CwDatepicker['noCalendar']) {};
  
  set placeholder(_: Components.CwDatepicker['placeholder']) {};
    /**
   *  @default CwDatePickerPosition.AUTO
   */
  set position(_: Components.CwDatepicker['position']) {};
  
  set readonly(_: Components.CwDatepicker['readonly']) {};
  
  set required(_: Components.CwDatepicker['required']) {};
  
  set showAmPm(_: Components.CwDatepicker['showAmPm']) {};
  
  set status(_: Components.CwDatepicker['status']) {};
  
  set weekNumbers(_: Components.CwDatepicker['weekNumbers']) {};
    /**
   *  @default 10
   */
  set yearsBefore(_: Components.CwDatepicker['yearsBefore']) {};
    /**
   *  @default 10
   */
  set yearsAfter(_: Components.CwDatepicker['yearsAfter']) {};
  
  set locale(_: Components.CwDatepicker['locale']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwDatepicker['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwDatepicker['ariaLabelledby']) {};
    /**
   *  @default undefined
   */
  set ariaDescribedby(_: Components.CwDatepicker['ariaDescribedby']) {};
  
  set value(_: Components.CwDatepicker['value']) {};
    /**
   *  @default false
   */
  set open(_: Components.CwDatepicker['open']) {};
  @Output() dateChange = new EventEmitter<CwDatepickerCustomEvent<ICwDatepickerCwDatePickerEmitValue>>();
  @Output() calendarOpen = new EventEmitter<CwDatepickerCustomEvent<void>>();
  @Output() calendarClose = new EventEmitter<CwDatepickerCustomEvent<ICwDatepickerCwDatePickerEmitValue>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwDatepickerCustomEvent } from '@bbraun/cortex-web/dist/components';
import type { CwDatePickerEmitValue as ICwDatepickerCwDatePickerEmitValue } from '@bbraun/cortex-web/dist/components';

export declare interface CwDatepicker extends Components.CwDatepicker {

  dateChange: EventEmitter<CwDatepickerCustomEvent<ICwDatepickerCwDatePickerEmitValue>>;

  calendarOpen: EventEmitter<CwDatepickerCustomEvent<void>>;

  calendarClose: EventEmitter<CwDatepickerCustomEvent<ICwDatepickerCwDatePickerEmitValue>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwDialog,
  inputs: ['ariaDescribedby', 'ariaLabelledby', 'dialogTitle', 'open', 'size']
})
@Component({
  selector: 'cw-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaDescribedby', 'ariaLabelledby', 'dialogTitle', 'open', 'size'],
  outputs: ['dialogClosed'],
})
export class CwDialog {
  protected el: HTMLCwDialogElement;
    /**
   *  @default false
   */
  set open(_: Components.CwDialog['open']) {};
    /**
   *  @default ''
   */
  set dialogTitle(_: Components.CwDialog['dialogTitle']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwDialog['ariaLabelledby']) {};
    /**
   *  @default undefined
   */
  set ariaDescribedby(_: Components.CwDialog['ariaDescribedby']) {};
    /**
   *  @default DialogSizes.M
   */
  set size(_: Components.CwDialog['size']) {};
  @Output() dialogClosed = new EventEmitter<CwDialogCustomEvent<MouseEvent>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwDialogCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwDialog extends Components.CwDialog {

  dialogClosed: EventEmitter<CwDialogCustomEvent<MouseEvent>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwDivider,
  inputs: ['ariaLabel', 'axis', 'status', 'type']
})
@Component({
  selector: 'cw-divider',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'axis', 'status', 'type'],
})
export class CwDivider {
  protected el: HTMLCwDividerElement;
    /**
   *  @default 'horizontal'
   */
  set axis(_: Components.CwDivider['axis']) {};
    /**
   *  @default 'default'
   */
  set type(_: Components.CwDivider['type']) {};
    /**
   *  @default 'default'
   */
  set status(_: Components.CwDivider['status']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwDivider['ariaLabel']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwDivider extends Components.CwDivider {}


@ProxyCmp({
  defineCustomElementFn: defineCwDropdown,
  inputs: ['ariaLabel', 'ariaLabelledby', 'assistiveText', 'disabled', 'label', 'multiple', 'placeholder', 'readonly', 'required', 'status', 'value']
})
@Component({
  selector: 'cw-dropdown',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelledby', 'assistiveText', 'disabled', 'label', 'multiple', 'placeholder', 'readonly', 'required', 'status', 'value'],
  outputs: ['valueChanges'],
})
export class CwDropdown {
  protected el: HTMLCwDropdownElement;
  
  set value(_: Components.CwDropdown['value']) {};
    /**
   *  @default ''
   */
  set placeholder(_: Components.CwDropdown['placeholder']) {};
    /**
   *  @default false
   */
  set multiple(_: Components.CwDropdown['multiple']) {};
    /**
   *  @default ''
   */
  set label(_: Components.CwDropdown['label']) {};
    /**
   *  @default false
   */
  set required(_: Components.CwDropdown['required']) {};
  
  set status(_: Components.CwDropdown['status']) {};
    /**
   *  @default ''
   */
  set assistiveText(_: Components.CwDropdown['assistiveText']) {};
    /**
   *  @default false
   */
  set readonly(_: Components.CwDropdown['readonly']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwDropdown['disabled']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwDropdown['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwDropdown['ariaLabelledby']) {};
  @Output() valueChanges = new EventEmitter<CwDropdownCustomEvent<string[] | string>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwDropdownCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwDropdown extends Components.CwDropdown {

  valueChanges: EventEmitter<CwDropdownCustomEvent<string[] | string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwDropdownGroup,
  inputs: ['label', 'multiple']
})
@Component({
  selector: 'cw-dropdown-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['label', 'multiple'],
})
export class CwDropdownGroup {
  protected el: HTMLCwDropdownGroupElement;
  
  set label(_: Components.CwDropdownGroup['label']) {};
  
  set multiple(_: Components.CwDropdownGroup['multiple']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwDropdownGroup extends Components.CwDropdownGroup {}


@ProxyCmp({
  defineCustomElementFn: defineCwDropdownItem,
  inputs: ['disabled', 'label', 'selected', 'value']
})
@Component({
  selector: 'cw-dropdown-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled', 'label', 'selected', 'value'],
  outputs: ['selectChange'],
})
export class CwDropdownItem {
  protected el: HTMLCwDropdownItemElement;
  
  set value(_: Components.CwDropdownItem['value']) {};
  
  set label(_: Components.CwDropdownItem['label']) {};
    /**
   *  @default false
   */
  set selected(_: Components.CwDropdownItem['selected']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwDropdownItem['disabled']) {};
  @Output() selectChange = new EventEmitter<CwDropdownItemCustomEvent<ICwDropdownItemDropdownItem>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwDropdownItemCustomEvent } from '@bbraun/cortex-web/dist/components';
import type { DropdownItem as ICwDropdownItemDropdownItem } from '@bbraun/cortex-web/dist/components';

export declare interface CwDropdownItem extends Components.CwDropdownItem {

  selectChange: EventEmitter<CwDropdownItemCustomEvent<ICwDropdownItemDropdownItem>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwExpansionPanel,
  inputs: ['ariaLabel', 'ariaLabelledby', 'disabled', 'font', 'heading', 'icon', 'opened', 'type'],
  methods: ['close']
})
@Component({
  selector: 'cw-expansion-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelledby', 'disabled', 'font', 'heading', 'icon', 'opened', 'type'],
  outputs: ['expansionStatusChange'],
})
export class CwExpansionPanel {
  protected el: HTMLCwExpansionPanelElement;
  
  set heading(_: Components.CwExpansionPanel['heading']) {};
    /**
   *  @default false
   */
  set opened(_: Components.CwExpansionPanel['opened']) {};
  
  set disabled(_: Components.CwExpansionPanel['disabled']) {};
    /**
   *  @default 'accordion'
   */
  set type(_: Components.CwExpansionPanel['type']) {};
    /**
   *  @default 'swap-icon'
   */
  set icon(_: Components.CwExpansionPanel['icon']) {};
    /**
   *  @default 'material'
   */
  set font(_: Components.CwExpansionPanel['font']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwExpansionPanel['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwExpansionPanel['ariaLabelledby']) {};
  @Output() expansionStatusChange = new EventEmitter<CwExpansionPanelCustomEvent<boolean>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwExpansionPanelCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwExpansionPanel extends Components.CwExpansionPanel {

  expansionStatusChange: EventEmitter<CwExpansionPanelCustomEvent<boolean>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwFileItem,
  inputs: ['disableControls', 'errorMessage', 'hideControls', 'name', 'progress', 'progressAriaLabel', 'reUploadAriaLabel', 'removeAriaLabel', 'size', 'status', 'uploadCompleteAriaLabel']
})
@Component({
  selector: 'cw-file-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disableControls', 'errorMessage', 'hideControls', 'name', 'progress', 'progressAriaLabel', 'reUploadAriaLabel', 'removeAriaLabel', 'size', 'status', 'uploadCompleteAriaLabel'],
  outputs: ['fileRemoved', 'fileReUploaded'],
})
export class CwFileItem {
  protected el: HTMLCwFileItemElement;
  
  set name(_: Components.CwFileItem['name']) {};
  
  set size(_: Components.CwFileItem['size']) {};
  
  set status(_: Components.CwFileItem['status']) {};
  
  set progress(_: Components.CwFileItem['progress']) {};
  
  set errorMessage(_: Components.CwFileItem['errorMessage']) {};
    /**
   *  @default false
   */
  set disableControls(_: Components.CwFileItem['disableControls']) {};
    /**
   *  @default false
   */
  set hideControls(_: Components.CwFileItem['hideControls']) {};
    /**
   *  @default undefined
   */
  set reUploadAriaLabel(_: Components.CwFileItem['reUploadAriaLabel']) {};
    /**
   *  @default undefined
   */
  set removeAriaLabel(_: Components.CwFileItem['removeAriaLabel']) {};
    /**
   *  @default undefined
   */
  set uploadCompleteAriaLabel(_: Components.CwFileItem['uploadCompleteAriaLabel']) {};
    /**
   *  @default undefined
   */
  set progressAriaLabel(_: Components.CwFileItem['progressAriaLabel']) {};
  @Output() fileRemoved = new EventEmitter<CwFileItemCustomEvent<string>>();
  @Output() fileReUploaded = new EventEmitter<CwFileItemCustomEvent<string>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwFileItemCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwFileItem extends Components.CwFileItem {

  fileRemoved: EventEmitter<CwFileItemCustomEvent<string>>;

  fileReUploaded: EventEmitter<CwFileItemCustomEvent<string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwFileUploader,
  inputs: ['ariaLabel', 'ariaLabelledby', 'buttonText', 'description', 'disabled', 'fileTypes', 'files', 'heading', 'multiple', 'progressAriaLabel', 'reUploadAriaLabel', 'removeAriaLabel', 'type', 'uploadCompleteAriaLabel']
})
@Component({
  selector: 'cw-file-uploader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelledby', 'buttonText', 'description', 'disabled', 'fileTypes', 'files', 'heading', 'multiple', 'progressAriaLabel', 'reUploadAriaLabel', 'removeAriaLabel', 'type', 'uploadCompleteAriaLabel'],
  outputs: ['fileSelected', 'fileRemoved', 'fileReUploaded', 'fileDeleted'],
})
export class CwFileUploader {
  protected el: HTMLCwFileUploaderElement;
  
  set heading(_: Components.CwFileUploader['heading']) {};
  
  set description(_: Components.CwFileUploader['description']) {};
  
  set buttonText(_: Components.CwFileUploader['buttonText']) {};
    /**
   *  @default 'primary'
   */
  set type(_: Components.CwFileUploader['type']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwFileUploader['disabled']) {};
    /**
   *  @default []
   */
  set fileTypes(_: Components.CwFileUploader['fileTypes']) {};
    /**
   *  @default false
   */
  set multiple(_: Components.CwFileUploader['multiple']) {};
    /**
   *  @default []
   */
  set files(_: Components.CwFileUploader['files']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwFileUploader['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwFileUploader['ariaLabelledby']) {};
    /**
   *  @default undefined
   */
  set reUploadAriaLabel(_: Components.CwFileUploader['reUploadAriaLabel']) {};
    /**
   *  @default undefined
   */
  set removeAriaLabel(_: Components.CwFileUploader['removeAriaLabel']) {};
    /**
   *  @default undefined
   */
  set uploadCompleteAriaLabel(_: Components.CwFileUploader['uploadCompleteAriaLabel']) {};
    /**
   *  @default undefined
   */
  set progressAriaLabel(_: Components.CwFileUploader['progressAriaLabel']) {};
  @Output() fileSelected = new EventEmitter<CwFileUploaderCustomEvent<File[]>>();
  @Output() fileRemoved = new EventEmitter<CwFileUploaderCustomEvent<ICwFileUploaderCwFileProgressItem>>();
  @Output() fileReUploaded = new EventEmitter<CwFileUploaderCustomEvent<ICwFileUploaderCwFileProgressItem>>();
  @Output() fileDeleted = new EventEmitter<CwFileUploaderCustomEvent<ICwFileUploaderCwFileProgressItem>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwFileUploaderCustomEvent } from '@bbraun/cortex-web/dist/components';
import type { CwFileProgressItem as ICwFileUploaderCwFileProgressItem } from '@bbraun/cortex-web/dist/components';

export declare interface CwFileUploader extends Components.CwFileUploader {

  fileSelected: EventEmitter<CwFileUploaderCustomEvent<File[]>>;

  fileRemoved: EventEmitter<CwFileUploaderCustomEvent<ICwFileUploaderCwFileProgressItem>>;

  fileReUploaded: EventEmitter<CwFileUploaderCustomEvent<ICwFileUploaderCwFileProgressItem>>;

  fileDeleted: EventEmitter<CwFileUploaderCustomEvent<ICwFileUploaderCwFileProgressItem>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwHeader,
  inputs: ['ariaControls', 'ariaLabel', 'ariaLabelledby']
})
@Component({
  selector: 'cw-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaControls', 'ariaLabel', 'ariaLabelledby'],
})
export class CwHeader {
  protected el: HTMLCwHeaderElement;
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwHeader['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwHeader['ariaLabelledby']) {};
    /**
   *  @default undefined
   */
  set ariaControls(_: Components.CwHeader['ariaControls']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwHeader extends Components.CwHeader {}


@ProxyCmp({
  defineCustomElementFn: defineCwIcon,
  inputs: ['ariaHidden', 'ariaLabel', 'filled', 'font', 'icon', 'size']
})
@Component({
  selector: 'cw-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaHidden', 'ariaLabel', 'filled', 'font', 'icon', 'size'],
})
export class CwIcon {
  protected el: HTMLCwIconElement;
    /**
   *  @default ''
   */
  set icon(_: Components.CwIcon['icon']) {};
    /**
   *  @default 'sm'
   */
  set size(_: Components.CwIcon['size']) {};
    /**
   *  @default 'material'
   */
  set font(_: Components.CwIcon['font']) {};
    /**
   *  @default false
   */
  set filled(_: Components.CwIcon['filled']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwIcon['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaHidden(_: Components.CwIcon['ariaHidden']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwIcon extends Components.CwIcon {}


@ProxyCmp({
  defineCustomElementFn: defineCwImage,
  inputs: ['alt', 'ariaLabel', 'ariaLabelledby', 'bordered', 'height', 'minHeight', 'minWidth', 'placeholder', 'size', 'src', 'width']
})
@Component({
  selector: 'cw-image',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['alt', 'ariaLabel', 'ariaLabelledby', 'bordered', 'height', 'minHeight', 'minWidth', 'placeholder', 'size', 'src', 'width'],
})
export class CwImage {
  protected el: HTMLCwImageElement;
    /**
   *  @default 'fluid'
   */
  set size(_: Components.CwImage['size']) {};
  
  set src(_: Components.CwImage['src']) {};
    /**
   *  @default ''
   */
  set placeholder(_: Components.CwImage['placeholder']) {};
  
  set alt(_: Components.CwImage['alt']) {};
    /**
   *  @default false
   */
  set bordered(_: Components.CwImage['bordered']) {};
    /**
   *  @default ''
   */
  set width(_: Components.CwImage['width']) {};
    /**
   *  @default ''
   */
  set height(_: Components.CwImage['height']) {};
    /**
   *  @default ''
   */
  set minHeight(_: Components.CwImage['minHeight']) {};
    /**
   *  @default ''
   */
  set minWidth(_: Components.CwImage['minWidth']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwImage['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwImage['ariaLabelledby']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwImage extends Components.CwImage {}


@ProxyCmp({
  defineCustomElementFn: defineCwInput,
  inputs: ['ariaLabel', 'ariaLabelledby', 'assistiveText', 'decimalPlaces', 'decimalSeparator', 'disabled', 'hideAssistive', 'integerOnly', 'label', 'max', 'maxlength', 'measure', 'min', 'minlength', 'name', 'pattern', 'placeholder', 'readonly', 'required', 'status', 'step', 'type', 'useThousandSeparator', 'value'],
  methods: ['focus']
})
@Component({
  selector: 'cw-input',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelledby', 'assistiveText', 'decimalPlaces', 'decimalSeparator', 'disabled', 'hideAssistive', 'integerOnly', 'label', 'max', 'maxlength', 'measure', 'min', 'minlength', 'name', 'pattern', 'placeholder', 'readonly', 'required', 'status', 'step', 'type', 'useThousandSeparator', 'value'],
  outputs: ['valueChange'],
})
export class CwInput {
  protected el: HTMLCwInputElement;
  
  set disabled(_: Components.CwInput['disabled']) {};
  
  set max(_: Components.CwInput['max']) {};
  
  set maxlength(_: Components.CwInput['maxlength']) {};
  
  set min(_: Components.CwInput['min']) {};
  
  set minlength(_: Components.CwInput['minlength']) {};
    /**
   *  @default null
   */
  set name(_: Components.CwInput['name']) {};
    /**
   *  @default null
   */
  set pattern(_: Components.CwInput['pattern']) {};
    /**
   *  @default null
   */
  set placeholder(_: Components.CwInput['placeholder']) {};
  
  set readonly(_: Components.CwInput['readonly']) {};
  
  set required(_: Components.CwInput['required']) {};
  
  set status(_: Components.CwInput['status']) {};
    /**
   *  @default 1
   */
  set step(_: Components.CwInput['step']) {};
    /**
   *  @default 'text'
   */
  set type(_: Components.CwInput['type']) {};
    /**
   *  @default null
   */
  set label(_: Components.CwInput['label']) {};
  
  set assistiveText(_: Components.CwInput['assistiveText']) {};
    /**
   *  @default ''
   */
  set measure(_: Components.CwInput['measure']) {};
    /**
   *  @default false
   */
  set hideAssistive(_: Components.CwInput['hideAssistive']) {};
    /**
   *  @default null
   */
  set value(_: Components.CwInput['value']) {};
    /**
   *  @default 'dot'
   */
  set decimalSeparator(_: Components.CwInput['decimalSeparator']) {};
    /**
   *  @default false
   */
  set useThousandSeparator(_: Components.CwInput['useThousandSeparator']) {};
    /**
   *  @default false
   */
  set integerOnly(_: Components.CwInput['integerOnly']) {};
  
  set decimalPlaces(_: Components.CwInput['decimalPlaces']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwInput['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwInput['ariaLabelledby']) {};
  @Output() valueChange = new EventEmitter<CwInputCustomEvent<string>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwInputCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwInput extends Components.CwInput {

  valueChange: EventEmitter<CwInputCustomEvent<string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwInputAssistive,
  inputs: ['disabled', 'required', 'status']
})
@Component({
  selector: 'cw-input-assistive',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled', 'required', 'status'],
})
export class CwInputAssistive {
  protected el: HTMLCwInputAssistiveElement;
  
  set disabled(_: Components.CwInputAssistive['disabled']) {};
  
  set required(_: Components.CwInputAssistive['required']) {};
  
  set status(_: Components.CwInputAssistive['status']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwInputAssistive extends Components.CwInputAssistive {}


@ProxyCmp({
  defineCustomElementFn: defineCwInputLabel,
  inputs: ['disabled', 'required']
})
@Component({
  selector: 'cw-input-label',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled', 'required'],
})
export class CwInputLabel {
  protected el: HTMLCwInputLabelElement;
  
  set disabled(_: Components.CwInputLabel['disabled']) {};
  
  set required(_: Components.CwInputLabel['required']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwInputLabel extends Components.CwInputLabel {}


@ProxyCmp({
  defineCustomElementFn: defineCwInputNumber,
  inputs: ['ariaLabel', 'ariaLabelledby', 'assistiveText', 'blockedChars', 'decimalPlaces', 'decimalSeparator', 'decreaseAriaLabel', 'disabled', 'increaseAriaLabel', 'label', 'max', 'measure', 'min', 'placeholder', 'readonly', 'required', 'status', 'step', 'useThousandSeparator', 'value']
})
@Component({
  selector: 'cw-input-number',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelledby', 'assistiveText', 'blockedChars', 'decimalPlaces', 'decimalSeparator', 'decreaseAriaLabel', 'disabled', 'increaseAriaLabel', 'label', 'max', 'measure', 'min', 'placeholder', 'readonly', 'required', 'status', 'step', 'useThousandSeparator', 'value'],
  outputs: ['valueChange'],
})
export class CwInputNumber {
  protected el: HTMLCwInputNumberElement;
  
  set min(_: Components.CwInputNumber['min']) {};
  
  set max(_: Components.CwInputNumber['max']) {};
    /**
   *  @default 1
   */
  set step(_: Components.CwInputNumber['step']) {};
    /**
   *  @default false
   */
  set readonly(_: Components.CwInputNumber['readonly']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwInputNumber['disabled']) {};
    /**
   *  @default false
   */
  set required(_: Components.CwInputNumber['required']) {};
  
  set label(_: Components.CwInputNumber['label']) {};
    /**
   *  @default ''
   */
  set placeholder(_: Components.CwInputNumber['placeholder']) {};
    /**
   *  @default 0
   */
  set value(_: Components.CwInputNumber['value']) {};
  
  set assistiveText(_: Components.CwInputNumber['assistiveText']) {};
    /**
   *  @default ''
   */
  set measure(_: Components.CwInputNumber['measure']) {};
  
  set status(_: Components.CwInputNumber['status']) {};
    /**
   *  @default ''
   */
  set blockedChars(_: Components.CwInputNumber['blockedChars']) {};
    /**
   *  @default 0
   */
  set decimalPlaces(_: Components.CwInputNumber['decimalPlaces']) {};
    /**
   *  @default 'dot'
   */
  set decimalSeparator(_: Components.CwInputNumber['decimalSeparator']) {};
    /**
   *  @default false
   */
  set useThousandSeparator(_: Components.CwInputNumber['useThousandSeparator']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwInputNumber['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwInputNumber['ariaLabelledby']) {};
    /**
   *  @default undefined
   */
  set decreaseAriaLabel(_: Components.CwInputNumber['decreaseAriaLabel']) {};
    /**
   *  @default undefined
   */
  set increaseAriaLabel(_: Components.CwInputNumber['increaseAriaLabel']) {};
  @Output() valueChange = new EventEmitter<CwInputNumberCustomEvent<number>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwInputNumberCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwInputNumber extends Components.CwInputNumber {

  valueChange: EventEmitter<CwInputNumberCustomEvent<number>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwList,
  inputs: ['ariaDescribedby', 'ariaLabel', 'ariaLabelledby', 'clickable', 'gutterLess', 'hideLastDivider', 'listTitle']
})
@Component({
  selector: 'cw-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaDescribedby', 'ariaLabel', 'ariaLabelledby', 'clickable', 'gutterLess', 'hideLastDivider', 'listTitle'],
})
export class CwList {
  protected el: HTMLCwListElement;
  
  set listTitle(_: Components.CwList['listTitle']) {};
  
  set gutterLess(_: Components.CwList['gutterLess']) {};
  
  set clickable(_: Components.CwList['clickable']) {};
  
  set hideLastDivider(_: Components.CwList['hideLastDivider']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwList['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwList['ariaLabelledby']) {};
    /**
   *  @default undefined
   */
  set ariaDescribedby(_: Components.CwList['ariaDescribedby']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwList extends Components.CwList {}


@ProxyCmp({
  defineCustomElementFn: defineCwListItem,
  inputs: ['active', 'caption', 'disabled', 'itemTitle', 'status', 'subtitle']
})
@Component({
  selector: 'cw-list-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'caption', 'disabled', 'itemTitle', 'status', 'subtitle'],
})
export class CwListItem {
  protected el: HTMLCwListItemElement;
  
  set caption(_: Components.CwListItem['caption']) {};
  
  set itemTitle(_: Components.CwListItem['itemTitle']) {};
  
  set subtitle(_: Components.CwListItem['subtitle']) {};
  
  set active(_: Components.CwListItem['active']) {};
  
  set disabled(_: Components.CwListItem['disabled']) {};
    /**
   *  @default 'default'
   */
  set status(_: Components.CwListItem['status']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwListItem extends Components.CwListItem {}


@ProxyCmp({
  defineCustomElementFn: defineCwListItemDescription,
  inputs: ['active', 'disabled', 'label', 'status', 'value']
})
@Component({
  selector: 'cw-list-item-description',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'disabled', 'label', 'status', 'value'],
})
export class CwListItemDescription {
  protected el: HTMLCwListItemDescriptionElement;
  
  set label(_: Components.CwListItemDescription['label']) {};
  
  set value(_: Components.CwListItemDescription['value']) {};
  
  set active(_: Components.CwListItemDescription['active']) {};
  
  set disabled(_: Components.CwListItemDescription['disabled']) {};
    /**
   *  @default 'default'
   */
  set status(_: Components.CwListItemDescription['status']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwListItemDescription extends Components.CwListItemDescription {}


@ProxyCmp({
  defineCustomElementFn: defineCwLogo,
  inputs: ['ariaLabel', 'claim', 'logoColor', 'width']
})
@Component({
  selector: 'cw-logo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'claim', 'logoColor', 'width'],
})
export class CwLogo {
  protected el: HTMLCwLogoElement;
    /**
   *  @default false
   */
  set claim(_: Components.CwLogo['claim']) {};
    /**
   *  @default 'green'
   */
  set logoColor(_: Components.CwLogo['logoColor']) {};
    /**
   *  @default 191
   */
  set width(_: Components.CwLogo['width']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwLogo['ariaLabel']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwLogo extends Components.CwLogo {}


@ProxyCmp({
  defineCustomElementFn: defineCwMenu,
  inputs: ['ariaLabel', 'autoOpen', 'closeOnSelect', 'closeOnTriggerClick', 'disabled', 'maxWidth', 'placement', 'readonly'],
  methods: ['open', 'close']
})
@Component({
  selector: 'cw-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'autoOpen', 'closeOnSelect', 'closeOnTriggerClick', 'disabled', 'maxWidth', 'placement', 'readonly'],
  outputs: ['menuToggle'],
})
export class CwMenu {
  protected el: HTMLCwMenuElement;
    /**
   *  @default '13.6785rem'
   */
  set maxWidth(_: Components.CwMenu['maxWidth']) {};
    /**
   *  @default true
   */
  set closeOnSelect(_: Components.CwMenu['closeOnSelect']) {};
    /**
   *  @default true
   */
  set closeOnTriggerClick(_: Components.CwMenu['closeOnTriggerClick']) {};
    /**
   *  @default true
   */
  set autoOpen(_: Components.CwMenu['autoOpen']) {};
    /**
   *  @default false
   */
  set readonly(_: Components.CwMenu['readonly']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwMenu['disabled']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwMenu['ariaLabel']) {};
    /**
   *  @default 'bottom-start'
   */
  set placement(_: Components.CwMenu['placement']) {};
  @Output() menuToggle = new EventEmitter<CwMenuCustomEvent<boolean>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwMenuCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwMenu extends Components.CwMenu {

  menuToggle: EventEmitter<CwMenuCustomEvent<boolean>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwMenuItem,
  inputs: ['active', 'disabled', 'focused', 'menuType']
})
@Component({
  selector: 'cw-menu-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'disabled', 'focused', 'menuType'],
  outputs: ['click'],
})
export class CwMenuItem {
  protected el: HTMLCwMenuItemElement;
    /**
   *  @default false
   */
  set active(_: Components.CwMenuItem['active']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwMenuItem['disabled']) {};
    /**
   *  @default false
   */
  set focused(_: Components.CwMenuItem['focused']) {};
    /**
   *  @default 'default'
   */
  set menuType(_: Components.CwMenuItem['menuType']) {};
  @Output() click = new EventEmitter<CwMenuItemCustomEvent<MouseEvent>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwMenuItemCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwMenuItem extends Components.CwMenuItem {

  click: EventEmitter<CwMenuItemCustomEvent<MouseEvent>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwNavigationDrawer,
  inputs: ['ariaLabel', 'ariaLabelledby', 'collapseLabel', 'collapsed', 'collapsible', 'drawerLabel', 'expandLabel']
})
@Component({
  selector: 'cw-navigation-drawer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelledby', 'collapseLabel', 'collapsed', 'collapsible', 'drawerLabel', 'expandLabel'],
})
export class CwNavigationDrawer {
  protected el: HTMLCwNavigationDrawerElement;
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwNavigationDrawer['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwNavigationDrawer['ariaLabelledby']) {};
    /**
   *  @default false
   */
  set collapsible(_: Components.CwNavigationDrawer['collapsible']) {};
    /**
   *  @default false
   */
  set collapsed(_: Components.CwNavigationDrawer['collapsed']) {};
  
  set drawerLabel(_: Components.CwNavigationDrawer['drawerLabel']) {};
    /**
   *  @default undefined
   */
  set expandLabel(_: Components.CwNavigationDrawer['expandLabel']) {};
    /**
   *  @default undefined
   */
  set collapseLabel(_: Components.CwNavigationDrawer['collapseLabel']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwNavigationDrawer extends Components.CwNavigationDrawer {}


@ProxyCmp({
  defineCustomElementFn: defineCwNavigationDrawerGroup,
  inputs: ['expanded', 'font', 'heading', 'icon']
})
@Component({
  selector: 'cw-navigation-drawer-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['expanded', 'font', 'heading', 'icon'],
})
export class CwNavigationDrawerGroup {
  protected el: HTMLCwNavigationDrawerGroupElement;
  
  set heading(_: Components.CwNavigationDrawerGroup['heading']) {};
    /**
   *  @default 'change_circle'
   */
  set icon(_: Components.CwNavigationDrawerGroup['icon']) {};
    /**
   *  @default 'material'
   */
  set font(_: Components.CwNavigationDrawerGroup['font']) {};
    /**
   *  @default false
   */
  set expanded(_: Components.CwNavigationDrawerGroup['expanded']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwNavigationDrawerGroup extends Components.CwNavigationDrawerGroup {}


@ProxyCmp({
  defineCustomElementFn: defineCwNavigationDrawerItem,
  inputs: ['badgeStatus', 'badgeStatusAriaLabel', 'badgeStatusIcon', 'badgeStatusLabel', 'badgeStatusPriority', 'badgeValue', 'font', 'icon', 'label']
})
@Component({
  selector: 'cw-navigation-drawer-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['badgeStatus', 'badgeStatusAriaLabel', 'badgeStatusIcon', 'badgeStatusLabel', 'badgeStatusPriority', 'badgeValue', 'font', 'icon', 'label'],
})
export class CwNavigationDrawerItem {
  protected el: HTMLCwNavigationDrawerItemElement;
  
  set icon(_: Components.CwNavigationDrawerItem['icon']) {};
    /**
   *  @default 'material'
   */
  set font(_: Components.CwNavigationDrawerItem['font']) {};
  
  set label(_: Components.CwNavigationDrawerItem['label']) {};
  
  set badgeValue(_: Components.CwNavigationDrawerItem['badgeValue']) {};
    /**
   *  @default BadgeStatusPriority.MEDIUM
   */
  set badgeStatusPriority(_: Components.CwNavigationDrawerItem['badgeStatusPriority']) {};
    /**
   *  @default BadgeStatus.SUCCESS
   */
  set badgeStatus(_: Components.CwNavigationDrawerItem['badgeStatus']) {};
    /**
   *  @default undefined
   */
  set badgeStatusLabel(_: Components.CwNavigationDrawerItem['badgeStatusLabel']) {};
    /**
   *  @default undefined
   */
  set badgeStatusAriaLabel(_: Components.CwNavigationDrawerItem['badgeStatusAriaLabel']) {};
    /**
   *  @default undefined
   */
  set badgeStatusIcon(_: Components.CwNavigationDrawerItem['badgeStatusIcon']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwNavigationDrawerItem extends Components.CwNavigationDrawerItem {}


@ProxyCmp({
  defineCustomElementFn: defineCwNavigationDrawerSection,
  inputs: ['heading']
})
@Component({
  selector: 'cw-navigation-drawer-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['heading'],
})
export class CwNavigationDrawerSection {
  protected el: HTMLCwNavigationDrawerSectionElement;
  
  set heading(_: Components.CwNavigationDrawerSection['heading']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwNavigationDrawerSection extends Components.CwNavigationDrawerSection {}


@ProxyCmp({
  defineCustomElementFn: defineCwNavigationRail,
  inputs: ['ariaLabel', 'ariaLabelledby']
})
@Component({
  selector: 'cw-navigation-rail',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelledby'],
})
export class CwNavigationRail {
  protected el: HTMLCwNavigationRailElement;
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwNavigationRail['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwNavigationRail['ariaLabelledby']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwNavigationRail extends Components.CwNavigationRail {}


@ProxyCmp({
  defineCustomElementFn: defineCwNavigationRailGroup,
  inputs: ['font', 'heading', 'icon', 'showBadgeNotification']
})
@Component({
  selector: 'cw-navigation-rail-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['font', 'heading', 'icon', 'showBadgeNotification'],
})
export class CwNavigationRailGroup {
  protected el: HTMLCwNavigationRailGroupElement;
  
  set icon(_: Components.CwNavigationRailGroup['icon']) {};
    /**
   *  @default 'cortex'
   */
  set font(_: Components.CwNavigationRailGroup['font']) {};
    /**
   *  @default false
   */
  set showBadgeNotification(_: Components.CwNavigationRailGroup['showBadgeNotification']) {};
  
  set heading(_: Components.CwNavigationRailGroup['heading']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwNavigationRailGroup extends Components.CwNavigationRailGroup {}


@ProxyCmp({
  defineCustomElementFn: defineCwNavigationRailItem,
  inputs: ['badgeStatus', 'badgeStatusAriaLabel', 'badgeStatusIcon', 'badgeStatusLabel', 'badgeStatusPriority', 'badgeText', 'disabled', 'expandable', 'font', 'icon', 'name', 'showBadgeNotification']
})
@Component({
  selector: 'cw-navigation-rail-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['badgeStatus', 'badgeStatusAriaLabel', 'badgeStatusIcon', 'badgeStatusLabel', 'badgeStatusPriority', 'badgeText', 'disabled', 'expandable', 'font', 'icon', 'name', 'showBadgeNotification'],
})
export class CwNavigationRailItem {
  protected el: HTMLCwNavigationRailItemElement;
    /**
   *  @default ''
   */
  set icon(_: Components.CwNavigationRailItem['icon']) {};
    /**
   *  @default ''
   */
  set name(_: Components.CwNavigationRailItem['name']) {};
  
  set disabled(_: Components.CwNavigationRailItem['disabled']) {};
    /**
   *  @default 'material'
   */
  set font(_: Components.CwNavigationRailItem['font']) {};
    /**
   *  @default false
   */
  set showBadgeNotification(_: Components.CwNavigationRailItem['showBadgeNotification']) {};
    /**
   *  @default false
   */
  set expandable(_: Components.CwNavigationRailItem['expandable']) {};
  
  set badgeText(_: Components.CwNavigationRailItem['badgeText']) {};
    /**
   *  @default BadgeStatusPriority.MEDIUM
   */
  set badgeStatusPriority(_: Components.CwNavigationRailItem['badgeStatusPriority']) {};
    /**
   *  @default BadgeStatus.SUCCESS
   */
  set badgeStatus(_: Components.CwNavigationRailItem['badgeStatus']) {};
    /**
   *  @default undefined
   */
  set badgeStatusLabel(_: Components.CwNavigationRailItem['badgeStatusLabel']) {};
    /**
   *  @default undefined
   */
  set badgeStatusAriaLabel(_: Components.CwNavigationRailItem['badgeStatusAriaLabel']) {};
    /**
   *  @default undefined
   */
  set badgeStatusIcon(_: Components.CwNavigationRailItem['badgeStatusIcon']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwNavigationRailItem extends Components.CwNavigationRailItem {}


@ProxyCmp({
  defineCustomElementFn: defineCwNavigationRailSection
})
@Component({
  selector: 'cw-navigation-rail-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: [],
})
export class CwNavigationRailSection {
  protected el: HTMLCwNavigationRailSectionElement;
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwNavigationRailSection extends Components.CwNavigationRailSection {}


@ProxyCmp({
  defineCustomElementFn: defineCwNavigationRailTitle,
  inputs: ['name']
})
@Component({
  selector: 'cw-navigation-rail-title',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['name'],
})
export class CwNavigationRailTitle {
  protected el: HTMLCwNavigationRailTitleElement;
    /**
   *  @default ''
   */
  set name(_: Components.CwNavigationRailTitle['name']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwNavigationRailTitle extends Components.CwNavigationRailTitle {}


@ProxyCmp({
  defineCustomElementFn: defineCwPagination,
  inputs: ['ariaLabel', 'ariaLabelFirstPage', 'ariaLabelLastPage', 'ariaLabelNextPage', 'ariaLabelPage', 'ariaLabelPreviousPage', 'count', 'currentPage', 'itemsPerPageDefault', 'itemsPerPageMessage', 'itemsPerPageOptions', 'numberOfItemsMessage', 'showItemsPerPage']
})
@Component({
  selector: 'cw-pagination',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelFirstPage', 'ariaLabelLastPage', 'ariaLabelNextPage', 'ariaLabelPage', 'ariaLabelPreviousPage', 'count', 'currentPage', 'itemsPerPageDefault', 'itemsPerPageMessage', 'itemsPerPageOptions', 'numberOfItemsMessage', 'showItemsPerPage'],
  outputs: ['pageChange', 'numberOfItemsChange'],
})
export class CwPagination {
  protected el: HTMLCwPaginationElement;
    /**
   *  @default 0
   */
  set currentPage(_: Components.CwPagination['currentPage']) {};
  
  set count(_: Components.CwPagination['count']) {};
  
  set itemsPerPageDefault(_: Components.CwPagination['itemsPerPageDefault']) {};
    /**
   *  @default [20, 40, 80, 120]
   */
  set itemsPerPageOptions(_: Components.CwPagination['itemsPerPageOptions']) {};
  
  set itemsPerPageMessage(_: Components.CwPagination['itemsPerPageMessage']) {};
  
  set numberOfItemsMessage(_: Components.CwPagination['numberOfItemsMessage']) {};
    /**
   *  @default true
   */
  set showItemsPerPage(_: Components.CwPagination['showItemsPerPage']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwPagination['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelFirstPage(_: Components.CwPagination['ariaLabelFirstPage']) {};
    /**
   *  @default undefined
   */
  set ariaLabelPreviousPage(_: Components.CwPagination['ariaLabelPreviousPage']) {};
    /**
   *  @default undefined
   */
  set ariaLabelNextPage(_: Components.CwPagination['ariaLabelNextPage']) {};
    /**
   *  @default undefined
   */
  set ariaLabelLastPage(_: Components.CwPagination['ariaLabelLastPage']) {};
    /**
   *  @default undefined
   */
  set ariaLabelPage(_: Components.CwPagination['ariaLabelPage']) {};
  @Output() pageChange = new EventEmitter<CwPaginationCustomEvent<number>>();
  @Output() numberOfItemsChange = new EventEmitter<CwPaginationCustomEvent<number>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwPaginationCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwPagination extends Components.CwPagination {

  pageChange: EventEmitter<CwPaginationCustomEvent<number>>;

  numberOfItemsChange: EventEmitter<CwPaginationCustomEvent<number>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwPaginationControls,
  inputs: ['ariaLabelFirstPage', 'ariaLabelLastPage', 'ariaLabelNextPage', 'ariaLabelPage', 'ariaLabelPreviousPage', 'currentPage', 'totalPages']
})
@Component({
  selector: 'cw-pagination-controls',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabelFirstPage', 'ariaLabelLastPage', 'ariaLabelNextPage', 'ariaLabelPage', 'ariaLabelPreviousPage', 'currentPage', 'totalPages'],
  outputs: ['pageChange'],
})
export class CwPaginationControls {
  protected el: HTMLCwPaginationControlsElement;
    /**
   *  @default 1
   */
  set totalPages(_: Components.CwPaginationControls['totalPages']) {};
    /**
   *  @default 0
   */
  set currentPage(_: Components.CwPaginationControls['currentPage']) {};
    /**
   *  @default undefined
   */
  set ariaLabelFirstPage(_: Components.CwPaginationControls['ariaLabelFirstPage']) {};
    /**
   *  @default undefined
   */
  set ariaLabelPreviousPage(_: Components.CwPaginationControls['ariaLabelPreviousPage']) {};
    /**
   *  @default undefined
   */
  set ariaLabelNextPage(_: Components.CwPaginationControls['ariaLabelNextPage']) {};
    /**
   *  @default undefined
   */
  set ariaLabelLastPage(_: Components.CwPaginationControls['ariaLabelLastPage']) {};
    /**
   *  @default undefined
   */
  set ariaLabelPage(_: Components.CwPaginationControls['ariaLabelPage']) {};
  @Output() pageChange = new EventEmitter<CwPaginationControlsCustomEvent<number>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwPaginationControlsCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwPaginationControls extends Components.CwPaginationControls {

  pageChange: EventEmitter<CwPaginationControlsCustomEvent<number>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwPopover,
  inputs: ['displayCloseIcon', 'heading', 'size', 'trigger', 'type']
})
@Component({
  selector: 'cw-popover',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['displayCloseIcon', 'heading', 'size', 'trigger', 'type'],
  outputs: ['open', 'close'],
})
export class CwPopover {
  protected el: HTMLCwPopoverElement;
    /**
   *  @default CwPopoverTrigger.Hover
   */
  set trigger(_: Components.CwPopover['trigger']) {};
  
  set heading(_: Components.CwPopover['heading']) {};
    /**
   *  @default false
   */
  set displayCloseIcon(_: Components.CwPopover['displayCloseIcon']) {};
    /**
   *  @default CwPopoverSize.MD
   */
  set size(_: Components.CwPopover['size']) {};
    /**
   *  @default 'default'
   */
  set type(_: Components.CwPopover['type']) {};
  @Output() open = new EventEmitter<CwPopoverCustomEvent<void>>();
  @Output() close = new EventEmitter<CwPopoverCustomEvent<void>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwPopoverCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwPopover extends Components.CwPopover {

  open: EventEmitter<CwPopoverCustomEvent<void>>;

  close: EventEmitter<CwPopoverCustomEvent<void>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwPopoverHeader,
  inputs: ['displayCloseIcon', 'heading', 'isFTE']
})
@Component({
  selector: 'cw-popover-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['displayCloseIcon', 'heading', 'isFTE'],
  outputs: ['close'],
})
export class CwPopoverHeader {
  protected el: HTMLCwPopoverHeaderElement;
  
  set heading(_: Components.CwPopoverHeader['heading']) {};
  
  set displayCloseIcon(_: Components.CwPopoverHeader['displayCloseIcon']) {};
    /**
   *  @default false
   */
  set isFTE(_: Components.CwPopoverHeader['isFTE']) {};
  @Output() close = new EventEmitter<CwPopoverHeaderCustomEvent<void>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwPopoverHeaderCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwPopoverHeader extends Components.CwPopoverHeader {

  close: EventEmitter<CwPopoverHeaderCustomEvent<void>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwProgressBar,
  inputs: ['animation', 'ariaLabel', 'ariaValuetext', 'size', 'status', 'transparent', 'value']
})
@Component({
  selector: 'cw-progress-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['animation', 'ariaLabel', 'ariaValuetext', 'size', 'status', 'transparent', 'value'],
})
export class CwProgressBar {
  protected el: HTMLCwProgressBarElement;
  
  set value(_: Components.CwProgressBar['value']) {};
    /**
   *  @default 4
   */
  set size(_: Components.CwProgressBar['size']) {};
    /**
   *  @default false
   */
  set transparent(_: Components.CwProgressBar['transparent']) {};
    /**
   *  @default 'none'
   */
  set animation(_: Components.CwProgressBar['animation']) {};
    /**
   *  @default 'default'
   */
  set status(_: Components.CwProgressBar['status']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwProgressBar['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaValuetext(_: Components.CwProgressBar['ariaValuetext']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwProgressBar extends Components.CwProgressBar {}


@ProxyCmp({
  defineCustomElementFn: defineCwRadioButton,
  inputs: ['ariaDescribedby', 'ariaLabel', 'checked', 'disabled', 'name', 'value'],
  methods: ['setFocus', 'select']
})
@Component({
  selector: 'cw-radio-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaDescribedby', 'ariaLabel', 'checked', 'disabled', 'name', 'value'],
  outputs: ['toggleRadioButton'],
})
export class CwRadioButton {
  protected el: HTMLCwRadioButtonElement;
  
  set value(_: Components.CwRadioButton['value']) {};
    /**
   *  @default false
   */
  set checked(_: Components.CwRadioButton['checked']) {};
  
  set name(_: Components.CwRadioButton['name']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwRadioButton['disabled']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwRadioButton['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaDescribedby(_: Components.CwRadioButton['ariaDescribedby']) {};
  @Output() toggleRadioButton = new EventEmitter<CwRadioButtonCustomEvent<number | string>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwRadioButtonCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwRadioButton extends Components.CwRadioButton {

  toggleRadioButton: EventEmitter<CwRadioButtonCustomEvent<number | string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwRadioGroup,
  inputs: ['ariaDescribedby', 'ariaLabel', 'ariaLabelledby', 'toolbarMode']
})
@Component({
  selector: 'cw-radio-group',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaDescribedby', 'ariaLabel', 'ariaLabelledby', 'toolbarMode'],
  outputs: ['radioButtonChange'],
})
export class CwRadioGroup {
  protected el: HTMLCwRadioGroupElement;
    /**
   *  @default false
   */
  set toolbarMode(_: Components.CwRadioGroup['toolbarMode']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwRadioGroup['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwRadioGroup['ariaLabelledby']) {};
    /**
   *  @default undefined
   */
  set ariaDescribedby(_: Components.CwRadioGroup['ariaDescribedby']) {};
  @Output() radioButtonChange = new EventEmitter<CwRadioGroupCustomEvent<string | number>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwRadioGroupCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwRadioGroup extends Components.CwRadioGroup {

  radioButtonChange: EventEmitter<CwRadioGroupCustomEvent<string | number>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwSearchbar,
  inputs: ['ariaLabel', 'ariaLabelClear', 'disabled', 'hideOnEmptySearch', 'loading', 'loadingMessage', 'noResultsMessage', 'placeholder', 'results', 'value']
})
@Component({
  selector: 'cw-searchbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelClear', 'disabled', 'hideOnEmptySearch', 'loading', 'loadingMessage', 'noResultsMessage', 'placeholder', 'results', 'value'],
  outputs: ['searchValueChange', 'submitValue'],
})
export class CwSearchbar {
  protected el: HTMLCwSearchbarElement;
    /**
   *  @default []
   */
  set results(_: Components.CwSearchbar['results']) {};
    /**
   *  @default ''
   */
  set noResultsMessage(_: Components.CwSearchbar['noResultsMessage']) {};
    /**
   *  @default ''
   */
  set loadingMessage(_: Components.CwSearchbar['loadingMessage']) {};
    /**
   *  @default ''
   */
  set value(_: Components.CwSearchbar['value']) {};
    /**
   *  @default false
   */
  set loading(_: Components.CwSearchbar['loading']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwSearchbar['disabled']) {};
    /**
   *  @default ''
   */
  set placeholder(_: Components.CwSearchbar['placeholder']) {};
    /**
   *  @default false
   */
  set hideOnEmptySearch(_: Components.CwSearchbar['hideOnEmptySearch']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwSearchbar['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelClear(_: Components.CwSearchbar['ariaLabelClear']) {};
  @Output() searchValueChange = new EventEmitter<CwSearchbarCustomEvent<string>>();
  @Output() submitValue = new EventEmitter<CwSearchbarCustomEvent<string>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwSearchbarCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwSearchbar extends Components.CwSearchbar {

  searchValueChange: EventEmitter<CwSearchbarCustomEvent<string>>;

  submitValue: EventEmitter<CwSearchbarCustomEvent<string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwSearchbarItem,
  inputs: ['active', 'focused', 'result']
})
@Component({
  selector: 'cw-searchbar-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['active', 'focused', 'result'],
})
export class CwSearchbarItem {
  protected el: HTMLCwSearchbarItemElement;
  
  set result(_: Components.CwSearchbarItem['result']) {};
    /**
   *  @default false
   */
  set active(_: Components.CwSearchbarItem['active']) {};
    /**
   *  @default false
   */
  set focused(_: Components.CwSearchbarItem['focused']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwSearchbarItem extends Components.CwSearchbarItem {}


@ProxyCmp({
  defineCustomElementFn: defineCwSidebar,
  inputs: ['actionButtonDisabled', 'actionButtonLabel', 'ariaLabel', 'ariaLabelCloseButton', 'ariaLabelledby', 'closeOnOutsideClick', 'heading', 'open', 'secondaryButtonDisabled', 'secondaryButtonLabel', 'showCloseButton']
})
@Component({
  selector: 'cw-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['actionButtonDisabled', 'actionButtonLabel', 'ariaLabel', 'ariaLabelCloseButton', 'ariaLabelledby', 'closeOnOutsideClick', 'heading', 'open', 'secondaryButtonDisabled', 'secondaryButtonLabel', 'showCloseButton'],
  outputs: ['sidebarClose', 'sidebarActionClick'],
})
export class CwSidebar {
  protected el: HTMLCwSidebarElement;
    /**
   *  @default false
   */
  set open(_: Components.CwSidebar['open']) {};
  
  set heading(_: Components.CwSidebar['heading']) {};
  
  set secondaryButtonLabel(_: Components.CwSidebar['secondaryButtonLabel']) {};
  
  set actionButtonLabel(_: Components.CwSidebar['actionButtonLabel']) {};
    /**
   *  @default true
   */
  set closeOnOutsideClick(_: Components.CwSidebar['closeOnOutsideClick']) {};
    /**
   *  @default true
   */
  set showCloseButton(_: Components.CwSidebar['showCloseButton']) {};
    /**
   *  @default false
   */
  set actionButtonDisabled(_: Components.CwSidebar['actionButtonDisabled']) {};
    /**
   *  @default false
   */
  set secondaryButtonDisabled(_: Components.CwSidebar['secondaryButtonDisabled']) {};
    /**
   *  @default undefined
   */
  set ariaLabelCloseButton(_: Components.CwSidebar['ariaLabelCloseButton']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwSidebar['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwSidebar['ariaLabelledby']) {};
  @Output() sidebarClose = new EventEmitter<CwSidebarCustomEvent<void>>();
  @Output() sidebarActionClick = new EventEmitter<CwSidebarCustomEvent<void>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwSidebarCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwSidebar extends Components.CwSidebar {

  sidebarClose: EventEmitter<CwSidebarCustomEvent<void>>;

  sidebarActionClick: EventEmitter<CwSidebarCustomEvent<void>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwSlider,
  inputs: ['ariaLabel', 'disabled', 'highValue', 'label', 'lowValue', 'max', 'min', 'readonly', 'required', 'showInput', 'showLabel', 'showMax', 'showMin', 'showTooltip', 'step', 'steps', 'type', 'value']
})
@Component({
  selector: 'cw-slider',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'disabled', 'highValue', 'label', 'lowValue', 'max', 'min', 'readonly', 'required', 'showInput', 'showLabel', 'showMax', 'showMin', 'showTooltip', 'step', 'steps', 'type', 'value'],
  outputs: ['valueChange', 'rangeChange'],
})
export class CwSlider {
  protected el: HTMLCwSliderElement;
    /**
   *  @default 0
   */
  set min(_: Components.CwSlider['min']) {};
    /**
   *  @default 100
   */
  set max(_: Components.CwSlider['max']) {};
    /**
   *  @default 1
   */
  set step(_: Components.CwSlider['step']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwSlider['disabled']) {};
    /**
   *  @default false
   */
  set readonly(_: Components.CwSlider['readonly']) {};
    /**
   *  @default ''
   */
  set label(_: Components.CwSlider['label']) {};
    /**
   *  @default false
   */
  set required(_: Components.CwSlider['required']) {};
    /**
   *  @default 0
   */
  set steps(_: Components.CwSlider['steps']) {};
    /**
   *  @default false
   */
  set showInput(_: Components.CwSlider['showInput']) {};
    /**
   *  @default false
   */
  set showTooltip(_: Components.CwSlider['showTooltip']) {};
    /**
   *  @default false
   */
  set showLabel(_: Components.CwSlider['showLabel']) {};
    /**
   *  @default false
   */
  set showMin(_: Components.CwSlider['showMin']) {};
    /**
   *  @default false
   */
  set showMax(_: Components.CwSlider['showMax']) {};
    /**
   *  @default 'simple'
   */
  set type(_: Components.CwSlider['type']) {};
    /**
   *  @default 0
   */
  set value(_: Components.CwSlider['value']) {};
    /**
   *  @default 0
   */
  set lowValue(_: Components.CwSlider['lowValue']) {};
    /**
   *  @default 100
   */
  set highValue(_: Components.CwSlider['highValue']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwSlider['ariaLabel']) {};
  @Output() valueChange = new EventEmitter<CwSliderCustomEvent<number>>();
  @Output() rangeChange = new EventEmitter<CwSliderCustomEvent<{ low: number; high: number }>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwSliderCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwSlider extends Components.CwSlider {

  valueChange: EventEmitter<CwSliderCustomEvent<number>>;

  rangeChange: EventEmitter<CwSliderCustomEvent<{ low: number; high: number }>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwSnackbar,
  inputs: ['ariaLabel']
})
@Component({
  selector: 'cw-snackbar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel'],
})
export class CwSnackbar {
  protected el: HTMLCwSnackbarElement;
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwSnackbar['ariaLabel']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwSnackbar extends Components.CwSnackbar {}


@ProxyCmp({
  defineCustomElementFn: defineCwSnackbarItem,
  inputs: ['item'],
  methods: ['pauseTimer', 'resumeTimer', 'focusPrimaryControl']
})
@Component({
  selector: 'cw-snackbar-item',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['item'],
  outputs: ['close', 'actionButtonClicked', 'closeButtonClicked'],
})
export class CwSnackbarItem {
  protected el: HTMLCwSnackbarItemElement;
  
  set item(_: Components.CwSnackbarItem['item']) {};
  @Output() close = new EventEmitter<CwSnackbarItemCustomEvent<ICwSnackbarItemSnackbarItem>>();
  @Output() actionButtonClicked = new EventEmitter<CwSnackbarItemCustomEvent<ICwSnackbarItemSnackbarItem>>();
  @Output() closeButtonClicked = new EventEmitter<CwSnackbarItemCustomEvent<ICwSnackbarItemSnackbarItem>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwSnackbarItemCustomEvent } from '@bbraun/cortex-web/dist/components';
import type { SnackbarItem as ICwSnackbarItemSnackbarItem } from '@bbraun/cortex-web/dist/components';

export declare interface CwSnackbarItem extends Components.CwSnackbarItem {

  close: EventEmitter<CwSnackbarItemCustomEvent<ICwSnackbarItemSnackbarItem>>;

  actionButtonClicked: EventEmitter<CwSnackbarItemCustomEvent<ICwSnackbarItemSnackbarItem>>;

  closeButtonClicked: EventEmitter<CwSnackbarItemCustomEvent<ICwSnackbarItemSnackbarItem>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwSpinner,
  inputs: ['ariaLabel', 'color', 'font']
})
@Component({
  selector: 'cw-spinner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'color', 'font'],
})
export class CwSpinner {
  protected el: HTMLCwSpinnerElement;
    /**
   *  @default 'default'
   */
  set color(_: Components.CwSpinner['color']) {};
    /**
   *  @default 'material'
   */
  set font(_: Components.CwSpinner['font']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwSpinner['ariaLabel']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwSpinner extends Components.CwSpinner {}


@ProxyCmp({
  defineCustomElementFn: defineCwSplashScreen,
  inputs: ['appName', 'ariaLabel', 'ariaLabelLoading', 'loading']
})
@Component({
  selector: 'cw-splash-screen',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['appName', 'ariaLabel', 'ariaLabelLoading', 'loading'],
})
export class CwSplashScreen {
  protected el: HTMLCwSplashScreenElement;
    /**
   *  @default 'Cortex Web'
   */
  set appName(_: Components.CwSplashScreen['appName']) {};
    /**
   *  @default false
   */
  set loading(_: Components.CwSplashScreen['loading']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwSplashScreen['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelLoading(_: Components.CwSplashScreen['ariaLabelLoading']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwSplashScreen extends Components.CwSplashScreen {}


@ProxyCmp({
  defineCustomElementFn: defineCwStepper,
  inputs: ['activeSlotId', 'ariaLabel', 'ariaLabelledby', 'axis', 'disableStepClicks', 'items']
})
@Component({
  selector: 'cw-stepper',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['activeSlotId', 'ariaLabel', 'ariaLabelledby', 'axis', 'disableStepClicks', 'items'],
  outputs: ['stepperChange'],
})
export class CwStepper {
  protected el: HTMLCwStepperElement;
    /**
   *  @default []
   */
  set items(_: Components.CwStepper['items']) {};
    /**
   *  @default undefined
   */
  set activeSlotId(_: Components.CwStepper['activeSlotId']) {};
    /**
   *  @default false
   */
  set disableStepClicks(_: Components.CwStepper['disableStepClicks']) {};
    /**
   *  @default 'horizontal'
   */
  set axis(_: Components.CwStepper['axis']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwStepper['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwStepper['ariaLabelledby']) {};
  @Output() stepperChange = new EventEmitter<CwStepperCustomEvent<string>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwStepperCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwStepper extends Components.CwStepper {

  stepperChange: EventEmitter<CwStepperCustomEvent<string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwTab,
  inputs: ['ariaLabel', 'ariaLabelledby', 'items', 'preventNavigation', 'selected']
})
@Component({
  selector: 'cw-tab',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelledby', 'items', 'preventNavigation', 'selected'],
  outputs: ['tabChange', 'tabContentValidate'],
})
export class CwTab {
  protected el: HTMLCwTabElement;
    /**
   *  @default []
   */
  set items(_: Components.CwTab['items']) {};
  
  set selected(_: Components.CwTab['selected']) {};
    /**
   *  @default false
   */
  set preventNavigation(_: Components.CwTab['preventNavigation']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwTab['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwTab['ariaLabelledby']) {};
  @Output() tabChange = new EventEmitter<CwTabCustomEvent<string>>();
  @Output() tabContentValidate = new EventEmitter<CwTabCustomEvent<ICwTabTabItem>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwTabCustomEvent } from '@bbraun/cortex-web/dist/components';
import type { TabItem as ICwTabTabItem } from '@bbraun/cortex-web/dist/components';

export declare interface CwTab extends Components.CwTab {

  tabChange: EventEmitter<CwTabCustomEvent<string>>;
  /**
   *  @deprecated The payload will be updated in the future to provide `from` and `to` tab information instead of the active tab.
   */
  tabContentValidate: EventEmitter<CwTabCustomEvent<ICwTabTabItem>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwTable,
  inputs: ['ariaLabel', 'columnDefs', 'currentPage', 'dateFilterOptions', 'dateFormat', 'disableColumnFlex', 'enableColumnVisibilityToggle', 'enableFiltering', 'enablePagination', 'enableRowSelection', 'fitColumnsSizeStrategy', 'gridOptions', 'initialSort', 'itemsPerPage', 'itemsPerPageMessage', 'itemsPerPageOptions', 'labels', 'loading', 'maxDateFilterValue', 'maxNumConditions', 'minDateFilterValue', 'numberFilterOptions', 'numberOfItemsMessage', 'numberOfRows', 'registryModules', 'rowData', 'rowSelectionMode', 'rowSelectionType', 'selectedRows', 'serverSide', 'serverSideFiltering', 'showItemsPerPage', 'sortable', 'suppressInteractiveRow', 'textFilterOptions']
})
@Component({
  selector: 'cw-table',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'columnDefs', 'currentPage', 'dateFilterOptions', 'dateFormat', 'disableColumnFlex', 'enableColumnVisibilityToggle', 'enableFiltering', 'enablePagination', 'enableRowSelection', 'fitColumnsSizeStrategy', 'gridOptions', 'initialSort', 'itemsPerPage', 'itemsPerPageMessage', 'itemsPerPageOptions', 'labels', 'loading', 'maxDateFilterValue', 'maxNumConditions', 'minDateFilterValue', 'numberFilterOptions', 'numberOfItemsMessage', 'numberOfRows', 'registryModules', 'rowData', 'rowSelectionMode', 'rowSelectionType', 'selectedRows', 'serverSide', 'serverSideFiltering', 'showItemsPerPage', 'sortable', 'suppressInteractiveRow', 'textFilterOptions'],
  outputs: ['pageChange', 'numberOfItemsChange', 'rowSelected', 'rowUnselected', 'columnsVisibilityChanged', 'filterApplied'],
})
export class CwTable {
  protected el: HTMLCwTableElement;
    /**
   *  @default []
   */
  set rowData(_: Components.CwTable['rowData']) {};
    /**
   *  @default []
   */
  set columnDefs(_: Components.CwTable['columnDefs']) {};
    /**
   *  @default {}
   */
  set gridOptions(_: Components.CwTable['gridOptions']) {};
    /**
   *  @default []
   */
  set registryModules(_: Components.CwTable['registryModules']) {};
    /**
   *  @default false
   */
  set loading(_: Components.CwTable['loading']) {};
    /**
   *  @default false
   */
  set sortable(_: Components.CwTable['sortable']) {};
    /**
   *  @default { ...CW_TABLE_LABELS }
   */
  set labels(_: Components.CwTable['labels']) {};
    /**
   *  @default false
   */
  set enableColumnVisibilityToggle(_: Components.CwTable['enableColumnVisibilityToggle']) {};
    /**
   *  @default false
   */
  set serverSide(_: Components.CwTable['serverSide']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwTable['ariaLabel']) {};
    /**
   *  @default false
   */
  set enableRowSelection(_: Components.CwTable['enableRowSelection']) {};
    /**
   *  @default false
   */
  set suppressInteractiveRow(_: Components.CwTable['suppressInteractiveRow']) {};
    /**
   *  @default 'singleRow'
   */
  set rowSelectionMode(_: Components.CwTable['rowSelectionMode']) {};
    /**
   *  @default 'click'
   */
  set rowSelectionType(_: Components.CwTable['rowSelectionType']) {};
    /**
   *  @default []
   */
  set selectedRows(_: Components.CwTable['selectedRows']) {};
    /**
   *  @default false
   */
  set enableFiltering(_: Components.CwTable['enableFiltering']) {};
    /**
   *  @default false
   */
  set serverSideFiltering(_: Components.CwTable['serverSideFiltering']) {};
    /**
   *  @default 1
   */
  set maxNumConditions(_: Components.CwTable['maxNumConditions']) {};
    /**
   *  @default new Date()
   */
  set maxDateFilterValue(_: Components.CwTable['maxDateFilterValue']) {};
    /**
   *  @default new Date(1900, 0, 1)
   */
  set minDateFilterValue(_: Components.CwTable['minDateFilterValue']) {};
    /**
   *  @default 'DD-MM-YYYY'
   */
  set dateFormat(_: Components.CwTable['dateFormat']) {};
    /**
   *  @default [
    ...CW_TABLE_TEXT_FILTER_OPTIONS,
  ]
   */
  set textFilterOptions(_: Components.CwTable['textFilterOptions']) {};
    /**
   *  @default [
    ...CW_TABLE_NUMBER_FILTER_OPTIONS,
  ]
   */
  set numberFilterOptions(_: Components.CwTable['numberFilterOptions']) {};
    /**
   *  @default [
    ...CW_TABLE_DATE_FILTER_OPTIONS,
  ]
   */
  set dateFilterOptions(_: Components.CwTable['dateFilterOptions']) {};
    /**
   *  @default false
   */
  set enablePagination(_: Components.CwTable['enablePagination']) {};
    /**
   *  @default 5
   */
  set itemsPerPage(_: Components.CwTable['itemsPerPage']) {};
    /**
   *  @default [5, 10, 50]
   */
  set itemsPerPageOptions(_: Components.CwTable['itemsPerPageOptions']) {};
    /**
   *  @default 0
   */
  set currentPage(_: Components.CwTable['currentPage']) {};
  
  set itemsPerPageMessage(_: Components.CwTable['itemsPerPageMessage']) {};
  
  set numberOfItemsMessage(_: Components.CwTable['numberOfItemsMessage']) {};
    /**
   *  @default true
   */
  set showItemsPerPage(_: Components.CwTable['showItemsPerPage']) {};
    /**
   *  @default 0
   */
  set numberOfRows(_: Components.CwTable['numberOfRows']) {};
  
  set initialSort(_: Components.CwTable['initialSort']) {};
    /**
   *  @default 'sizeColumnsToFit'
   */
  set fitColumnsSizeStrategy(_: Components.CwTable['fitColumnsSizeStrategy']) {};
    /**
   *  @default false
   */
  set disableColumnFlex(_: Components.CwTable['disableColumnFlex']) {};
  @Output() pageChange = new EventEmitter<CwTableCustomEvent<number>>();
  @Output() numberOfItemsChange = new EventEmitter<CwTableCustomEvent<number>>();
  @Output() rowSelected = new EventEmitter<CwTableCustomEvent<any>>();
  @Output() rowUnselected = new EventEmitter<CwTableCustomEvent<any>>();
  @Output() columnsVisibilityChanged = new EventEmitter<CwTableCustomEvent<ICwTableCwTableColumnVisibilityChangeData[]>>();
  @Output() filterApplied = new EventEmitter<CwTableCustomEvent<ICwTableFilterChangedEvent>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwTableCustomEvent } from '@bbraun/cortex-web/dist/components';
import type { CwTableColumnVisibilityChangeData as ICwTableCwTableColumnVisibilityChangeData } from '@bbraun/cortex-web/dist/components';
import type { FilterChangedEvent as ICwTableFilterChangedEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwTable extends Components.CwTable {

  pageChange: EventEmitter<CwTableCustomEvent<number>>;

  numberOfItemsChange: EventEmitter<CwTableCustomEvent<number>>;

  rowSelected: EventEmitter<CwTableCustomEvent<any>>;

  rowUnselected: EventEmitter<CwTableCustomEvent<any>>;

  columnsVisibilityChanged: EventEmitter<CwTableCustomEvent<ICwTableCwTableColumnVisibilityChangeData[]>>;

  filterApplied: EventEmitter<CwTableCustomEvent<ICwTableFilterChangedEvent>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwTableToggleColumn,
  inputs: ['params']
})
@Component({
  selector: 'cw-table-toggle-column',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['params'],
})
export class CwTableToggleColumn {
  protected el: HTMLCwTableToggleColumnElement;
  
  set params(_: Components.CwTableToggleColumn['params']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwTableToggleColumn extends Components.CwTableToggleColumn {}


@ProxyCmp({
  defineCustomElementFn: defineCwTextarea,
  inputs: ['ariaLabel', 'ariaLabelledby', 'assistiveText', 'cols', 'disabled', 'label', 'maxLength', 'minLength', 'placeholder', 'readOnly', 'required', 'resize', 'rows', 'status', 'value']
})
@Component({
  selector: 'cw-textarea',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaLabel', 'ariaLabelledby', 'assistiveText', 'cols', 'disabled', 'label', 'maxLength', 'minLength', 'placeholder', 'readOnly', 'required', 'resize', 'rows', 'status', 'value'],
  outputs: ['valueChange'],
})
export class CwTextarea {
  protected el: HTMLCwTextareaElement;
  
  set placeholder(_: Components.CwTextarea['placeholder']) {};
  
  set value(_: Components.CwTextarea['value']) {};
  
  set label(_: Components.CwTextarea['label']) {};
  
  set required(_: Components.CwTextarea['required']) {};
  
  set disabled(_: Components.CwTextarea['disabled']) {};
  
  set readOnly(_: Components.CwTextarea['readOnly']) {};
  
  set rows(_: Components.CwTextarea['rows']) {};
  
  set cols(_: Components.CwTextarea['cols']) {};
  
  set maxLength(_: Components.CwTextarea['maxLength']) {};
  
  set minLength(_: Components.CwTextarea['minLength']) {};
    /**
   *  @default ''
   */
  set assistiveText(_: Components.CwTextarea['assistiveText']) {};
  
  set status(_: Components.CwTextarea['status']) {};
    /**
   *  @default TextareaResize.NONE
   */
  set resize(_: Components.CwTextarea['resize']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwTextarea['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwTextarea['ariaLabelledby']) {};
  @Output() valueChange = new EventEmitter<CwTextareaCustomEvent<string>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwTextareaCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwTextarea extends Components.CwTextarea {

  valueChange: EventEmitter<CwTextareaCustomEvent<string>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwToggle,
  inputs: ['ariaDescribedby', 'ariaLabel', 'ariaLabelledby', 'checked', 'disabled', 'name']
})
@Component({
  selector: 'cw-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['ariaDescribedby', 'ariaLabel', 'ariaLabelledby', 'checked', 'disabled', 'name'],
  outputs: ['changed'],
})
export class CwToggle {
  protected el: HTMLCwToggleElement;
  
  set name(_: Components.CwToggle['name']) {};
    /**
   *  @default false
   */
  set checked(_: Components.CwToggle['checked']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwToggle['disabled']) {};
  
  set ariaLabel(_: Components.CwToggle['ariaLabel']) {};
  
  set ariaLabelledby(_: Components.CwToggle['ariaLabelledby']) {};
  
  set ariaDescribedby(_: Components.CwToggle['ariaDescribedby']) {};
  @Output() changed = new EventEmitter<CwToggleCustomEvent<boolean>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwToggleCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwToggle extends Components.CwToggle {

  changed: EventEmitter<CwToggleCustomEvent<boolean>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwTooltip,
  inputs: ['content', 'disabled', 'fillContainer', 'maxWidth', 'placement'],
  methods: ['show', 'hide']
})
@Component({
  selector: 'cw-tooltip',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['content', 'disabled', 'fillContainer', 'maxWidth', 'placement'],
})
export class CwTooltip {
  protected el: HTMLCwTooltipElement;
    /**
   *  @default null
   */
  set content(_: Components.CwTooltip['content']) {};
    /**
   *  @default 'bottom'
   */
  set placement(_: Components.CwTooltip['placement']) {};
    /**
   *  @default false
   */
  set fillContainer(_: Components.CwTooltip['fillContainer']) {};
    /**
   *  @default false
   */
  set disabled(_: Components.CwTooltip['disabled']) {};
    /**
   *  @default undefined
   */
  set maxWidth(_: Components.CwTooltip['maxWidth']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwTooltip extends Components.CwTooltip {}


@ProxyCmp({
  defineCustomElementFn: defineCwWizard,
  inputs: ['activeStepName', 'ariaDescribedby', 'ariaLabel', 'ariaLabelledby', 'hideBulletNavigation', 'open', 'showSkip', 'skipButtonLabel', 'steps']
})
@Component({
  selector: 'cw-wizard',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['activeStepName', 'ariaDescribedby', 'ariaLabel', 'ariaLabelledby', 'hideBulletNavigation', 'open', 'showSkip', 'skipButtonLabel', 'steps'],
  outputs: ['skip'],
})
export class CwWizard {
  protected el: HTMLCwWizardElement;
    /**
   *  @default false
   */
  set open(_: Components.CwWizard['open']) {};
    /**
   *  @default false
   */
  set showSkip(_: Components.CwWizard['showSkip']) {};
    /**
   *  @default ''
   */
  set skipButtonLabel(_: Components.CwWizard['skipButtonLabel']) {};
    /**
   *  @default []
   */
  set steps(_: Components.CwWizard['steps']) {};
    /**
   *  @default ''
   */
  set activeStepName(_: Components.CwWizard['activeStepName']) {};
    /**
   *  @default false
   */
  set hideBulletNavigation(_: Components.CwWizard['hideBulletNavigation']) {};
    /**
   *  @default undefined
   */
  set ariaLabel(_: Components.CwWizard['ariaLabel']) {};
    /**
   *  @default undefined
   */
  set ariaLabelledby(_: Components.CwWizard['ariaLabelledby']) {};
    /**
   *  @default undefined
   */
  set ariaDescribedby(_: Components.CwWizard['ariaDescribedby']) {};
  @Output() skip = new EventEmitter<CwWizardCustomEvent<void>>();
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


import type { CwWizardCustomEvent } from '@bbraun/cortex-web/dist/components';

export declare interface CwWizard extends Components.CwWizard {

  skip: EventEmitter<CwWizardCustomEvent<void>>;
}


@ProxyCmp({
  defineCustomElementFn: defineCwWizardActions,
  inputs: ['actions']
})
@Component({
  selector: 'cw-wizard-actions',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['actions'],
})
export class CwWizardActions {
  protected el: HTMLCwWizardActionsElement;
    /**
   *  @default []
   */
  set actions(_: Components.CwWizardActions['actions']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwWizardActions extends Components.CwWizardActions {}


@ProxyCmp({
  defineCustomElementFn: defineCwWizardBody,
  inputs: ['activeStep', 'hideBulletNavigation']
})
@Component({
  selector: 'cw-wizard-body',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['activeStep', 'hideBulletNavigation'],
})
export class CwWizardBody {
  protected el: HTMLCwWizardBodyElement;
  
  set activeStep(_: Components.CwWizardBody['activeStep']) {};
    /**
   *  @default false
   */
  set hideBulletNavigation(_: Components.CwWizardBody['hideBulletNavigation']) {};
  constructor(c: ChangeDetectorRef, r: ElementRef, protected z: NgZone) {
    c.detach();
    this.el = r.nativeElement;
  }
}


export declare interface CwWizardBody extends Components.CwWizardBody {}


